let data = require('./ja_z')
module.exports = {
  message: {
    ...data,
    cashbackCollectionLink: '入金リンク',
    cashbackCollectionDetails: '入金リンク明細',
    cashbackAmountYuan: '金額（元）',
    cashbackCollectionReason: '入金理由',
    cashbackListLoadFailed: '入金リンク一覧を取得できませんでした',
    cashbackListRetry: '再試行',
    cashbackCreateLink: '入金リンク作成',
    cashbackGenerateNow: '今すぐ作成',
    cashbackAmountPlaceholder: '金額を入力してください',
    cashbackReasonPlaceholder: '入金理由を入力してください',
    cashbackAmountInvalid: '0より大きく99999999.99以下の金額を小数点以下2桁までで入力してください',
    cashbackReasonRequired: '入金理由を入力してください',
    cashbackReasonTooLong: '入金理由は60000バイト（UTF-8）以内で入力してください',
    cashbackCreateUnconfirmed: '前回の送信結果を確認できていません。再試行して確認してください。金額と入金理由は一時的に変更できません。',
    cashbackVoidTitle: '無効化の確認',
    cashbackVoidMessage: '入金リンクを無効にすると、支払いができなくなり、直ちに失効します。この操作は取り消せません。確認のうえ無効にしてください。',
    cashbackConfirmDelete: '削除を確定',
    language: '语言',
    logOut: '退出登录',
    Chinese: '中文',
    Japanese: '日文',
    allPersonnel: '全部人员',
    permanentWorker: '正式工',
    temporaryWorker: '临时工',
    addMembers: '成员添加',
    systemAccount: '系统账号',
    name: '姓名',
    phoneNumber: '携帯番号',
    employeeId: '员工ID',
    setDefaultSealer: '封函担当者設定',
    defaultSealer: '封函担当者',
    selectDefaultSealer: '封函担当者を選択してください',
    sealerCandidatesLoadFailed: '封函担当者候補の読み込みに失敗しました',
    reloadSealerCandidates: '再読み込み',
    defaultSealerProgress: '設定進捗',
    porderWaitSeal: '封函待ち',
    porderSealed: '封函完了',
    adjustPorderSealer: '封函担当者変更',
    porderSealer: '封函担当者',
    batchSealPorders: '一括封函',
    sealPorder: '封函',
    confirmSealingComplete: '選択した配送伝票を封函完了にしますか？この操作は取り消せません。',
    sealingPorderLimit: '有効な配送伝票を1～200件選択してください',
    scopeOfPersonnel: '範囲',
    shelfUserPersonnel: '使用担当者',
    typeOfWork: '工种',
    newTypeOfWork: '工种:',
    search: '検索',
    reset: 'リセット',
    typeOfAccount: 'アカウントタイプ',
    realname: '真实姓名',
    sex: '性别',
    phone: '电话',
    chatDisplayName: '聊天显示名称',
    chatGroup: '聊天群组',
    newChatGroup: '聊天群组:',
    role: '角色',
    automaticSinglePrefix: '自动下单前缀',
    automaticallyOrderCustomParts: '自动下单自定义部分',
    youCanEnterSubsystemSettings: '可进入子系统设置',
    accountStatus: '可进入子系统设置',
    operation: '操作',
    operatingPersonne: '操作人员',
    accountToEdit: '账号编辑',
    editRole: '角色编辑',
    whetherToEnableTheAccount: '是否将此账号设置为启用状态',
    whetherToDisableTheAccount: '是否将此账号设置为停用状态',
    hint: '提示',
    confirm: '确 定',
    theSettingsHaveBeenCancelled: '已取消设置',
    sectoralStructure: '部门结构',
    add: '添加',
    redact: '编辑',
    delete: '删除',
    checkWhetherToDeleteTheCurrentLevelTheContentContainedInTheLevelWillBeDeletedSimultaneously: '确认是否删除当前层级，层级下包含内容会同步删除',
    editorialDepartment: '编辑部门',
    superiorDepartment: '上级部门:',
    clickTheDepartmentOptionToSearchAndDisplayTheCurrentDepartmentByDefault: '点击部门选项，可以搜索，默认显示当前部门',
    industryTitle: '部门名称:',
    newSubordinateDepartments: '新增下级部门',

    sureToClose: '确认关闭？',
    requiredFieldsAreMissing: '缺少必填项',
    organizationalStructure: '组织架构',
    usersList: '用户列表',
    editMemberInformation: '编辑成员信息',
    accountType: '账户类型:',
    newSystemAccount: '系统账号:',
    pleaseEnterTheSystemAccount: '请输入系统账号',
    systemHeadImage: '系统头像',
    pleaseEnterTheSystemHeadImage: '请选择系统头像',
    password: '密码:',
    enterYourPIN: '请输入密码',
    newRealname: '真实姓名:',
    pleaseEnterYourRealname: '请输入真实姓名:',
    newSex: '性别：',
    man: '男',
    girl: '女',
    telephoneNumber: '番号',
    return: '返回',
    pleaseEnterAChatName: '请输入聊天名称',
    pleaseEnterThePhoneNumber: '请输入电话号码',
    newPleaseEnterYourRealname: '请输入真实姓名',
    whetherToAddTheAccount: '是否添加该账号',
    theAdditionHasBeenCanceled: '已取消添加',
    whetherToModifyTheAccountInformation: '是否修改该账号的信息',
    modificationCancelled: '已取消修改',
    rolename: '角色名',
    theNewRole: '新增角色',
    characterName: '角色名称',
    organization: '组织',
    rolePermission: '角色权限',
    theRoleList: '角色列表',
    editingTheRole: '编辑角色',
    newCharacterName: '角色名称:',
    pleaseEnterARoleName: '请输入角色名称',
    typeOfWorkToChoose: '工种选择',
    department: '部门',
    automaticallyJoiningAGroup: '自动加入群组',
    doNotAutomaticallyJoinGroups: '不自动加入群组',
    pleaseSelectTheTypeOfWork: '请选择工种',
    pleaseSelectDepartment: '请选择部门',
    whetherToAddTheRole: '是否添加该角色',
    whetherToModifyTheRole: '是否修改该角色的信息',
    permissionSetting: '权限设置',
    menuPermissions: '菜单权限',
    operatingAuthorization: '操作権限',
    whetherToDeleteTheRole: '是否删除该角色',
    theDeletionHasBeenCancelled: '削除キャンセル',
    editRolesAndAccessSystemInformation: '编辑角色、可进入系统信息',
    accessToSubsystems: '可进入子系统：',
    pleaseSelectSubsystem: '请选择子系统',
    newRole: '角色：',
    pleaseSelectRoles: '请选择角色',
    roleChoices: '角色选择',
    whetherToSaveTheRoleBoundToTheAccountAndTheInformationThatCanBeAccessedToTheSystem: '是否要保存该账号绑定的角色和可进入系统信息',
    orderAddressSetting: '下单地址设置',
    notToChoose: '未選択',
    accountStatus: '账号状态',
    automaticallyAdd: '自动加入',
    notAutomaticallyAdded: '不自动加入',
    checkProductAttributes: '检品属性',
    configurationOfInspectionProperties: '检品属性配置',
    allocationProportion: '分配比例',


    speechLanguage: 'español', //西班牙语
    productProblem: '产品问题',
    customerData: '客户资料',
    customerFeedback: '客户意见',
    personnelManagement: '人员管理',
    unit: '元',
    Yen: '円',
    salesman: '担当者',
    logOut: '退出登录',
    orderForm: '订单',
    customerManagement: '客户管理',
    itemStatus: '商品状态',
    department: '部门',
    screenPeers: '筛选同层级人员',
    clickOnTheDepartmentOptionToSearch: '点击部门选项，可以搜索',
    internationalLogisticsMaintenance: '国际物流维护',
    sortNumber: '排序编号',
    logisticsId: '物流ID',
    sendingModeName: '发送方式名称',
    sendModeLogo: '发送方式logo',
    currentEffectiveTime: '当前生效时间',
    currentFreightCalculationMode: '当前运费计算模式',
    availableQuantityOfLogisticsTrackingNumber: '物流单号可用数量',
    currentSendingStatus: '当前发送状态',
    editTheDetails: '编辑详情',
    setTheSort: '设置排序',
    normalHair: '正常发',
    stopHair: '停发',
    LogisticsModeAddedTheForm: '物流方式新增表单',
    pleaseEnterTheNameOfTheNewLogisticsMode: '请输入新增的物流方式的名称',
    pleaseSelectTheLogisticsLogo: '请选择物流logo',
    logisticsLogo: '物流logo',
    whetherToDeleteTheSelectedLogistics: '是否删除选中的物流',
    whetherToChangeTheCurrentSendingStatusOfTheSelectedLogisticsToNormalSending: '是否将选中物流的当前发送状态修改为正常发',
    determineWhetherToChangeTheBookingStatusOfTheSelectedLogisticsToYes: '是否将选中物流的订柜状态修改为是',
    whetherToChangeTheCurrentSendingStatusOfTheSelectedLogisticsToStopSending: '是否将选中物流的当前发送状态修改为停发',
    whetherToChangeTheBookingStatusOfTheSelectedLogisticsToNo: '是否将选中物流的订柜状态修改为否',
    modificationCancelled: '已取消修改',
    whetherToSubmitTheLogisticsSortingModification: '是否提交物流排序修改',
    are: '是',
    no: '否',
    effectiveTime: '生效时间',
    modificationDate: '最后修改时间',
    freightCalculationMode: '运费计算模式',
    overviewOfCalculationRules: '计算规则概述',
    effectiveState: '生效状态',
    takeEffect: '生效',
    invalid: '未生效',
    editView: '编辑查看',
    toCopyA: '复制一条',
    newManualQuotationRules: '新人工报价规则',
    effectiveStartTime: '生效开始时间',
    validityEndTime: '生效结束时间',
    addedManualQuotationRules: '新增人工报价规则',
    setSpecificComputingRules: '具体计算规则设置',
    logisticsModeNumber: '物流方式编号',
    activeElementSettingsInRealTime: '实时生效元素设置',
    stateOfLogisticsMode: '物流方式状态',
    initiation: '开始',
    end: '结束',
    doYouNeedToBookAContainer: '是否需要订柜',
    expectedDaysInSpain: '预计西班牙天数',
    pleaseEnterTheExpectedDaysToSpain: '请输入预计到西班牙天数',
    whetherToChangeTheEffectiveStatusOfTheLogisticsCalculationRuleToEffective: '是否将物流计算规则的生效状态修改为生效',
    whetherToChangeTheEffectiveStatusOfTheLogisticsCalculationRuleToInvalid: '是否将物流计算规则的生效状态修改为未生效',
    theFormatOfUploadedImageResourceIsNotCorrect: '上传图片资源格式不正确',
    whetherToSaveTheLogisticsConfiguration: '是否保存物流配置',
    selectATimeForTheValidityToStart: '请选择生效开始时间',
    selectAnEndTimeForTheValidityPeriod: '请选择生效结束时间',
    revisedManualQuotationRules: '修改人工报价规则',
    saveSettings: '保存设置',
    proportionSet: '比例设置',
    theTotalNumberOfCustomers: '客户总数',
    accountNumber: '账号',
    role: '角色',
    departmentNumber: '部门成员',
    customerAllocationRatio: '客户分配比例',
    customerAllocation: '客户分配',
    customerIDMaybeOrderNumber: '客户ID/订单号',
    inquire: '查询',
    reset: 'リセット',
    advancedFilter: '詳細選択',
    allocation: '分配',
    clientID: 'お客様ID',
    customerName: 'お客様名',
    UserName: '用户名',
    loginName: '登录账号',
    typeOfAccount: 'アカウントタイプ',
    cellphoneNumber: '携帯番号',
    clientGrade: 'ランク',
    takeOn: '担当',
    authorityManagement: '权限管理',
    roleManagement: '角色管理',
    roleRightsAssignment: '角色权限分配',
    commodityMaterial: '品名材质',
    EstimateTheCostOfInternationalTransport: "预估国际运输费用",
    EstimatedDomesticDeliveryCostsInSpain: "预估西班牙国内派送费用",
    whetherToRecommend: '是否推荐',
    whetherTheStartingVolumeIsReached: '是否达到起发量',
    StartingVolumeRemarks: '起发量备注',
    EnterAgain: '重新输入',
    roleName: '角色名',
    typeOfWork: '工种',
    organization: '组织',
    creationTime: '创建时间',
    operation: '操作',
    returnsAListOf: '返回列表',
    menuPermissions: '菜单权限',
    operatingAuthorization: '操作権限',
    save: '保存',
    temporaryStorage: '臨時保存',
    generateSystemPurchaseNo: 'システム取引番号を生成',
    purchase: '采购',
    distribution: '配货',
    customerStatus: '客户状态',
    balance: '残高(円)',
    introducer: '講師',
    deliveryOrderAuthorization: '配送单授权',
    goldenAuthorization: '入金授权',
    registrationDate: '登録日',
    lastVisitTime: '直近ログイン',
    particulars: '详情',
    businessOrder: '业务订单',
    theOrderPrice: '订单报价',
    startDate: '開始日',
    startDateTC: '开始日期（提出）',
    dateClosedTC: '结束日期（提出）',
    dateClosed: '終了日',
    search: '検索',
    orderSubmissionTime: '提交订单时间',
    confirmCompletionTime: '确认完成时间',
    confirmCompletion: '确认完成',
    theOrderAttribute: '订单属性',
    orderNumber: '注文番号',
    order: '单号',
    business: '业务',
    ordersNumber: '订单番数',
    quotationStatus: '报价状态',
    serviceOrderRemarks: '业务订单备注',
    purchaseOrderRemarks: '采购订单备注',
    property: '属性',
    compile: '编辑',
    orderConfirmation: '订单确认',
    customerPresentationTime: '客户提出时间',
    translationTime: '翻译完了时间',
    ordersForTranslation: '订单翻译',
    orderInProgress: '进行中订单',
    selectionOfSalesman: '选择业务员',
    purchasingAgentSelection: '选择采购员',
    selectADistributor: '选择配货员',
    orderNumberMaybeCustomerName: '订单号/客户名称',
    orderDistribution: '注文No/配送依頼書No',
    userName: '名前',
    adjustTheBusiness: '调整业务',
    adjustTheArchitecture: '调整架构',
    adjustTheDistribution: '调整配货',
    deleteTheOrder: '注文書削除',
    withdrawTheRemainingCash: '回退待入金',
    operator: '担当',
    translate: '翻译',
    notarize: '確定',
    quotedPrice: '报价',
    quotedPriceNum: '报价数',
    customersIntoGold: '客户入金',
    golden: '入金',
    financialConfirmationOfTheDeposit: '财务确认入金',
    financialConfirmation: '确认入金',
    financialPayment: '财务付款',
    signForTime: '签收时间',
    hitTheShelf: '上架',
    hitTheShelfComplete: '上架完成',
    shelfCompletionTime: '上架完了時間',
    wholeOrderShelfCompleted: '注文全体の棚入れ完了',
    shelfCompletedLabel: '上架完了',
    shipmentComplete: '出货完成',
    purchaseComplete: '采购完成',
    buyer: '買付',
    distributionMember: '梱包',
    numberOfStores: '店铺数',
    numberOfGoods: '商品数',
    recipients: '收件人',
    recipientsPhone: '收件人电话',
    purchaseOrders: '订单采购',
    finishedPurchaseOrder: '购买完了订单',
    paymentOfAnOrder: '订单支付',
    paymentOfAnPorder: '配送单支付',
    businessOffer: '业务报价',
    orderSubmissionDate: '订单提交日期',
    confirmTheTime: '确认完了时间',
    setsetWebsite: '网站配置',
    classifyManage: '分类管理',
    CommodityClassification: '商品主分类',
    DefaultPersonalizedRecommendation: '默认个性化推荐',
    GeneralProductrecommendation: '普通商品推荐',
    AddTheClassification: '添加分类',
    ChineseName: '中文名称',
    translationName: '译文名称',
    sort: '排序',
    TheCigherClassification: '上级分类',
    defaultIcon: 'Web默认图标',
    triggerIcon: 'Web悬停图标',
    appImg: 'App图标',
    note: '描述',
    cancel: 'キャンセル',
    editClassification: 'キャンセル',
    areYouSureToDelete: '削除しますか？',
    prompt: '提示',
    confirmTheShutDown: '确认关闭？',
    pleaseChineseName: '请输入中文名称',
    KeywordsEnteredByTheCustomer: '客户输入的关键词',
    pleaseTranslationName: '请输入译文名称',
    theHigherTheNumber: '*数字越大越靠前',
    setCarousel: '轮播图设置',
    resultspreview: '效果预览',
    rollingFrequency: '滚动频率',
    carousel1: '注：保存生效',
    carousel2: '注：未保存，之前操作无效',
    instructions: '说明',
    seconds: '秒',
    addBanner: '添加Banner',
    skipLinks: '跳转链接',
    delete: '删除',
    status: '状態',
    allStatus: '全部状态',
    all: 'すべて',
    bannerConfiguration: 'Banner配置',
    staticBannerEdit: '静的バナー編集',
    bannerMainTitle: 'メインタイトル',
    bannerSubtitle: 'サブタイトル',
    newColumn: '新着コラム',
    readMore: '記事を読む',
    enterReasonForDeletion: '填写删除原因',
    adjustBusiness: '调整业务',
    adjustPurchase: '调整采购',
    adjustdistribution: '调整配货',
    deleteOrder: '注文書削除',
    withdrawRemaining: '回退待入金',
    storeInformation: '店铺信息',
    pic: '照片',
    commodityAttribute: '商品属性 ',
    standardCommodityCategory: '标准商品类别 ',
    standardGoods: '标准品名 ',
    standardMaterial: '标准材质 ',
    category: '类别',
    setName: '设置人',
    setStandard: '设置标准',
    allSetStandard: '批量设置标准',
    entryTime: '录入时间',
    material: '品名',
    texture: '材质',
    isSertificate: '是否需要证书',
    standardInformation: '标准信息 ',
    fllStandardInformation: '填充到标准信息 ',
    need: '需要',
    noNeed: '不需要',
    homePreview: '首页预览',
    commodityMaintenance: '品名维护',
    goodsReplacement: '商品更换 ',
    SyncHome: '同步到首页',
    recommend: '为你推荐',
    ok: '確定',
    modifyGoods: '修改商品',
    uoloadPic: '上传图片',
    originalGoods: '商品原图',
    previewPicture: '图片预览',
    originalNameCommodity: '商品原名称',
    translationCorrect: '译文修正',
    homePreviewAffirm: '确认之后商品原信息将会替换，是否确认?',
    financial: '财务',
    financialStoreList: '確認待ちリスト',
    forwardTime: '提出時間',
    accountingCategory: '口座',
    user: 'お客様',
    orderInformations: '单子信息',
    orderSum: '注文・配送書　金額',
    sum: '金额',
    methodPayment: '支払い方法',
    nameRemitter: '入金名義',
    name: '姓名',
    phone: '电话',
    remittanceAmount: '入金額',
    remittanceScreenshots: 'キャプチャー',
    transferNote: '備考欄',
    accountBalance: '账户余额(€)',
    accountBalance1: '账户余额',
    creditAmount: '貸付可能額',
    edit: '編集',
    rollback: '取り消し',
    confirmAmount: '确认后汇款额将在客户余额反应，请谨慎操作！',
    returnedAmount: '确认后将回退到待汇款状态，请谨慎操作！',
    rulePay_realname: '请输入汇款人姓名',
    rulePay_amount: '请输入汇款金额(€)',
    ruleBill_method: '请选择支付方式',
    rulePay_image: '请上传汇款截图',
    rulePay_remark: '请输入转账备注',
    ruleUser_id: '请输入客户ID',
    manualRegistrationRemittance: '手動登録',
    add: '追加',
    acknowledgingTime: '确认时间',
    emittanceState: '状態',
    affirmName: '確認人',
    addName: '追加人',
    confirmed: '確認済み',
    toBeConfirmed: '確認待ち',
    productPicture: '商品图片',
    chineseProductName: '中文商品名',
    productCategory: '商品类别',
    material: '品名',
    texture: '材质',
    materialCN: '品名（CN）',
    textureCN: '材质（CN）',
    materialSpain: '品名（Spain）',
    textureSpain: '材质（Spain）',
    materialEN: '品名（EN）',
    textureEN: '材质（EN）',
    customerPlacesAnOrder: '客户下单',
    quotationInStock: '报价在库数',
    quotationUnitPrice: '报价单价',
    quoteDomesticShipping: '报价国内运费',
    productCategorySelection: '商品类别选择',
    choose: '选择',
    commodityCategory: '商品品类',
    taxRate: '税率',
    whetherToSubmitProductNameEditing: '是否提交品名编辑?',
    submissionCancelled: '已取消提交',
    chooseSuccess: '选择成功!',
    investigateTheNumberOfInStock: '调查在库数',
    referenceUnitPrice: '参考单价',
    investigateDomesticShippingCosts: '调查国内运费',
    surveyUnitPrice: '调查单价',
    confirmDomesticShipping: '确认国内运费',
    volume: '体积',
    singleBoxVolume: '单箱体积',
    packingQuantity: '装箱量',
    singleNetWeight: '单个净重(g)',
    additionalServices: 'オプション',
    additionalServicesChinese: '附加服务中文名',
    additionalServicesJapanese: '附加服务日文名',
    warning: '警告',
    commodityBoxSizeWeight: '商品箱规/重量',
    businessReply: '业务回复',
    requiredFieldsAreMissing: '缺少必填项',
    noBuyerOrDistributorIsAssignedToThisOrder: '该订单未分配采购员和配货员',
    purchasingNotes: '采购备注',
    customerSingleNote: '客户单番备注',
    customerProductRemarks: '客户商品备注',
    businessTranslation: '业务翻译',
    businessTranslationUser: '业务翻译(给客户)',
    businessSbumit: '业务提出',
    addition: '追 加',
    orderDelete: '删 除',
    productWithTheSameId: '同ID商品',
    sameStoreProduct: '同店铺商品',
    copySelectedProductInformation: '复制选中商品信息',
    copyOrderProductInformation: '复制订单商品信息',
    copyProductInformation: '复制商品信息',
    returnToPurchase: '退给采购',
    procurement: '采购提出',
    replaceTheLink: '替换链接',
    replaceLinkEditing: '替换链接编辑',
    replaceNumber: '替换编号',
    serialNumber: '编号',
    ProductLink: '商品链接',
    makeAnOffer: '提出报价',
    domesticSubtotal: '国内小计',
    internationalSubtotal: '国际小计',
    estimatedShipping: '预估运费',
    customerOrderNotes: '客户订单备注',
    customerOrderRemarkReply: '客户订单备注回复',
    brandMaterial: '品牌材质',
    additionalServiceOptions: '附加服务选项',
    quantity: '数量',
    actualCharges: '实际收费标准',
    estimatedCost: '预计费用',
    indivual: '个',
    total: '合计',
    internationalShippingEstimate: '国际运费预估',
    theTotalArea: '总面积',
    calculate: '计算',
    shippingMethods: '物流方式',
    imageReplacementForm: '图片更换表单',
    upload: '上传',
    productAttributeSelectionForm: '商品属性选择表单',
    addProductForm: '追加商品表单',
    productLink: '商品链接：',
    productSColour: '商品颜色：',
    productSize: '商品尺寸：',
    numberOfProducts: '商品数量',
    commodityPrice: '商品单价',
    noProductFoundInTheSameStore: '没有找到同店铺的商品!',
    noProductWithTheSameIdWasFound: '没有找到同ID的商品!',
    whetherToReturnThisOrderToPurchaseForReconfirmation: '是否将此订单回退给采购重新确认?',
    thePeplacementItemCanBeDeletedOnlyWhenItContainsMoreThanOneItem: '替换商品数据大于一项时才可删除',
    pleaseEnterTheProductLink: '请输入商品链接',
    pleaseSelectUploadImage: '请选择上传图片',
    pleaseEnterTheQuantityOfGoods: '请输入商品数量',
    pleaseInputTheUnitPriceOfTheGoods: '请输入商品单价',
    whetherToSubmitProductExchangeLinkInformation: '是否提交商品换购链接信息',
    pleaseEnterTheLinkOfTheItemYouWantToReplace: '请输入要替换的商品链接',
    rollbackCanceled: '已取消回退',
    temporarySave: '臨時保存',
    whetherToSaveAttributeSelection: '是否保存属性选择?',
    productAttributesSelectedSuccessfully: '商品属性选择成功!',
    deselected: '已取消选择',
    whetherToSaveTheForm: '是否保存表单?',
    addedProductSuccessfully: '追加商品成功!',
    saveCancelled: '已取消保存',
    whetherToSaveAdditionalServices: '是否保存附加服务?',
    additionalServicesSavedSuccessfully: '附加服务保存成功',
    whetherToSaveImageReplacement: '是否保存图片更换',
    productImageReplacementSuccessfully: '商品图片更换成功!',
    replacementCancelled: '已取消更换',
    whetherToProposeAPurchase: '是否提出采购?',
    purchaseCancelled: '已取消采购',
    whetherToMakeAnOffer: '是否提出报价?',
    offerCancelled: '已取消报价',
    whetherToStartTranslation: '是否开始翻译?',
    translationCancelled: '已取消翻译',
    businessQuotationTime: '业务报价时间',
    financialConfirmationTime: '確認時間',
    financeModule: '财务模块',
    whetherToDeleteTheSelectedOrder: '是否删除选中的订单?',
    pleaseSelectAtLeastOne: '请至少选中一项!',
    successfullyDeleted: '删除成功！',
    undeleted: '削除キャンセル',
    confirmUnitPrice: '确认单价',
    return: '返回',
    whetherToReturnToThePreviousPage: '是否返回上一级页面',
    cancelledReturn: '已取消返回',
    customerPaymentTime: '客户付款时间',
    targetLaunchTime: '目标上架时间',
    orderStatus: '订单状态',
    check: '查看',
    orderTime: '订单时间点',
    fulfillmentOrderNotes: '配货订单备注',
    orderSubmission: '订单提出',
    orderTranslation: '订单翻译',
    customerSubmitsRemittance: '客户提交汇款',
    financialConfirmationRemittance: '财务确认汇款',
    theOrderTimePointCorrespondingToTheOrderWasNotFound: '未找到该订单对应的订单时间点',
    noCorrespondingOrderDetailsFound: '未找到相对应的订单详情',
    transactionNumber: '交易号',
    logisticsNumber: '物流号',
    theOrderIsFinished: '買付完了',
    inStock: '在库',
    unitPrice: '单价',
    unitPriceRMB: '单价(RMB)',
    unitPriceYen: '单价(日元)',
    unitPrice$: '单价(美元)',
    freight: '运费',
    atTheTimeOfPurchase: '购买时',
    afterFinancialPayment: '财务付款后',
    afterFinancialPaymentNum: '财务付款后数量',
    afterFinancialPaymentKin: '财务付款后金额',
    canBePutIntoStorage: '可入库',
    itHasArrived: '已到货',
    shipped: '已出货',
    beShipped: '待出货',
    salesmanCommodityRemarks: '业务员商品备注',
    remarksForPurchasedCommodities: '采购商品备注',
    deliveryProductRemarks: '配货商品备注',
    deliveryNoteNumber: '配送番号',
    internationalLogisticsOrderNumber: '国际物流单号',
    logisticsSingleNumber: '物流单号',
    commoditiesWithTheSameTransactionNumber: '同交易号商品',
    noProductWithTheSameTransactionNumberWasFound: '没有找到同交易号的商品',
    transactionNumberSplit: '交易号拆分',
    transactionNumberModification: '交易号修改',
    logisticsNumberAdded: '物流号添加',
    logisticsNumberModification: '物流号修改',
    logisticsNumberDeleted: '物流号删除',
    pleaseEditTheBrandMaterialFirstAndThenMakeAQuotation: '请先进行品牌材质编辑后再进行报价!',
    closure: '关闭',
    whetherToSubmitTheLogisticsNumberToAdd: '是否提交物流号添加',
    whetherToSubmitTheLogisticsNumberToAdd: '待删除物流号',
    theLogisticsNumberToBeDeleted: '待删除物流号',
    theLogisticsNumberToBeModified: '待修改物流号',
    checkAtMostOne: '至多选中一项',
    whetherToSubmitTheModificationOfTheLogisticsNumber: '是否提交物流号修改',
    noTrackingNumberFound: '没有找到物流单号',
    newLogisticsNumber: '新物流号',
    originalLogisticsNumber: '原物流号',
    modifiedLogisticsNumber: '修改后物流号',
    logisticsNumberToBeDeleted: '待删除物流号',
    whetherToSubmitTheLogisticsNumberToDelete: '是否提交物流号删除',
    pleaseSelectAnOrderWithTheExactSameTransactionNumber: '请选择交易号完全相同的订单',
    quote: '报价',
    timeToTranslate: '翻译完了时间',
    originalTransactionNumber: '原交易号数量',
    remainingAfterSplit: '拆分后剩余',
    numberOfNewTransactionNumbers: '新交易号数量',
    theNumberOfNewTransactionNumbersCannotBeGreaterThanTheNumberOfPreviousTransactionNumbers: '新交易号数量不能大于之前的交易号数量',
    theNewTransactionNumberIsNotFilledIn: '新交易号未填写',
    theNumberOfNewTransactionNumbersIsNotFilledIn: '新交易号数量未填写',
    theNumberOfNewTransactionNumbersMustBeGreaterThan0: '新交易号数量必须大于0',
    whetherToSubmitTransactionNumberSplit: '是否提交交易号拆分',
    transactionNumberAfterModification: '修改后交易号',
    whetherToSubmitTransactionNumberModification: '是否提交交易号修改',
    transactionIdNotFound: '没有找到交易号',
    viewSingleProductTimePoint: '单番商品时间点查看',
    pleaseFillInTheRemarksBeforeSubmitting: '请将备注填写完整后再进行提交',
    whetherToSubmitANote: '是否提交备注',
    userInfo: '会員',
    CheckInformation: '詳細',
    userBill: '客户收支明细',
    bookedTime: '入账时间',
    financialCategory: '口座',
    remittanceDetails: '汇款明细',
    purchaseList: '交易号付款',
    searchContent: '搜索内容',
    toBePayment: '待付款',
    payment: '已付款',
    purchaseTime: '采购购买时间',
    financialPaymentPime: '财务付款时间',
    mash: '番号',
    purchaseAccount: '购买账号',
    purchasingData: '采购数据',
    accountsPayable: '应付款',
    customerPayment: '客户付款',
    percentage: '百分比',
    extractingAmount: '抽取金额',
    paymentStatus: '付款状态',
    goodsAmount: '商品金额',
    domesticFreight: '国内运费',
    payments: '付款',
    clientsSun: '客户提现',
    applicationTime: '提出日',
    remittanceTime: '振込日',
    applicantInformation: 'お客様情報',
    applyWithdrawalAmount: '申请提现金额(€)',
    ApplicantsBankAccountInformation: '振込先',
    paymentScreenshots: '支付截图',
    remittance: '振込',
    cancellationRequest: '申請取消',
    confirmCancellationRequest: '确认后，该提现申请将被取消。需要申请人重新提出申请，请确认',
    pleaseEnterTheLogisticsNumber: '请输入物流号',
    pleaseEnterLogisticsNumberOrBadId: '物流番号/不良IDを入力してください',
    pleaseEnterBadId: '不良IDを入力してください',
    pleaseEnterTransactionNumber: '请输入交易号',
    theLastFiveDigitsOfTheOrderNumber: '订单号后五位',
    stockNumber: '在库数',
    price: '价格',
    businessCommodityRemarks: '业务商品备注',
    inspect: '核查',
    inspectionOfGoods: '核查检品',
    filter: '検索',
    editingOfTheRemarksForTheDeliveryProduct: '配货商品备注编辑',
    orderNumberAndCustomerName: '订单号及客户姓名',
    editingOfBusinessProductRemarks: '业务商品备注编辑',
    purchasingCommodityNotesedit: '采购商品备注编辑',
    pleaseEnterTheLogisticsNumberAndTransactionNumberBeforeChecking: '请输入物流号和交易号后再进行核查',
    sameTransactionNumberAndLogisticsNumber: '同交易号物流号',
    addInspectionList: '添加检品单',
    orderNotes: '订单备注',
    printPackageInformation: '打印包裹信息',
    link: '链接',
    copy: '复制',
    numberOfTransactionNumbers: '交易号数量',
    numberOfArrivalsThisTime: '本次到货数',
    theNumberOfItemsThatHaveBeenInspected: '已加检品单数',
    numberOfInspectionProblems: '检品问题数',
    numberOfProblemProducts: '问题产品数',
    inspector: '检品员',
    poorQuantity: '数量差',
    adverseNumber: '不良数',
    inspectionStatus: '检品状态',
    responsibleForRemarks: '担当备注',
    verifierSNotes: '核查员备注',
    askAQuestionAboutTheProduct: '提出问题产品',
    addToInspectionList: '加入检品单',
    markSpecialItems: '标记特殊商品',
    copySuccessfully: '复制成功',
    inspectionStatusDetails: '检品状态详情：',
    inspectionOrderNumber: '检品单号',
    numberToBeChecked: '应检数',
    checkNumber: '实检数',
    submitTheNumberOfBad: '提交不良数',
    submitInspectionTime: '提交检品时间',
    inspectionCompletionTime: '检品完成时间',
    currentState: '当前状态',
    whetherToAddThisProductToTheInspectionList: '是否将该商品加入到检品单中',
    cancelled: '已取消加入',
    whetherToSubmitTheProductForListing: '是否将该商品提交上架',
    numberOfProductsToBeSubmittedForInspection: '待提交检品数',
    numberOfProductsToBeInspected: '应检品数',
    numberOfFbaLabels: 'FBA贴标数',
    labeling: '贴标',
    selectTheSamePackage: '选中同包裹商品',
    removeFromInspectionList: '从检品单移除',
    inspectionListDiscarded: '检品单废弃',
    cancelInspection: '取消检品',
    packageSplit: '包裹拆分',
    inspectionListDeployment: '检品单调配',
    submitForInspection: '提交检品',
    printTheInspectionList: '打印检品单',
    whetherToRemoveTheItemFromTheInspectionList: '是否将该商品从检品单中移除',
    removed: '已取消移除',
    testArticlePersonSelect: '检品员选择',
    allChecked: '全选',
    actualFreight: '实际运费',
    actualPrice: '实际价格',
    sealSpending: '确认报价',
    quotationData: '实时数据',
    generate1688order: '生成1688订单',
    extractTransactionNumberAmount: '抽取交易号金额',
    pendingFinancialPayment: '待财务付款',
    pendingCancellationFinancialPayment: '待财务付款取消',
    questionProduct: '提出问题产品',
    userID: '会員ID',
    thereAreGoodsWaitingToBePaidByFinance: '有商品已经待财务付款，请确认后提交!',
    noTransactionNumberIsEntered: '有商品未填写交易号，请确认后提交',
    submitToFinanceForPayment: '是否确定提交到财务付款？',
    theFinancialDepartmentHasHotYetPaid: '有商品还未待财务付款，请确认后提交',
    returnToTreasurerTorPayment: '是否确定退回到待财务付款?',
    selectableOperational: '请选择要操作的订单',
    selectableOperationalList: '请选择要操作的列表',
    merchandiseToBePhotographed: '待拍下商品',
    couponsSpecified: '优惠券生成(指定客户)',
    voucherPackageManagement: '券包管理',
    stayOut: '配布待ち',
    ssued: '配布済み',
    hasBeenUsed: '使用済み',
    batchIssue: '批量发放',
    useTime: '使用时间',
    couponName: '券名称 ',
    couponNameXBY: '券名称(西班牙语) ',
    couponNunber: '券码编号',
    effectiveDate: '有效日期',
    amountEndNumberOfTimesAvailable: '额度/可用次数',
    vouchers: '代金券',
    coupons: '优惠券',
    useRestrictions: '使用限制',
    orderAmount: '订单金额',
    issue: '发放',
    pleaseSelectTheCouponToBeIssued: '请选择要放发的优惠券',
    issueCoupons: '确认是否发放该优惠券吗？',
    clientList: '客户列表',
    removeAll: '全部清除',
    selectCustomerGeneration: '选中客户生成',
    couponTemplate: 'クーポンテンプレート',
    templateManagement: '模板管理 ',
    number: '数量',
    couponsWhetherGeneratedImmediately: '请核对优惠券列表，是否立即生成？',
    inputCouponName: '请输入优惠券名称',
    inputCategorye: '请选择类别',
    TheCustomerSpecifiesTheModeOfTransportation: '客户指定运输方式', //客户指定运输方式
    totalVolume: '合计体积', //合计体积
    EstimatedInternationalFreightEUR: '预估国际运费EUR', //预估国际运费EUR
    SpainIsExpectedToDomesticDeliveryCosts: '预计西班牙国内派送费', //预计西班牙国内派送费
    AntidumpingDutyExpected: '预计反倾销税', //预计反倾销税
    ExpectedvalueAddedTax: '预计增值税', //预计增值税
    inputAmountEndNumberOfTimesAvailable: '请输入额度/可用次数',
    inputUseRestrictions: '请输入使用限制',
    allGoods: 'すべての商品',
    toBePhotographed: '等待拍下',
    TheGoodsWithTheArrivalNumberOf0AreNotSupportedToBePutOnShelves: '本次到货数为0的商品不支持上架',
    TheNumberOfGoodsDeliveredThisTimeCannotBeGreaterThanTheNumberOfPossibleShelvesWhichIsCurrently: '本次到货数不能大于上架可能数,当前上架可能数为',
    attention: '注意',
    ThereAreGoodsCorrespondingToTheDistributorIsNotTheCurrentLoggedInDistributorPleaseConfirmBeforeOperation: '有商品对应配货员不是当前登录配货员！请确认后再操作',
    whetherToCancelTheInspectionOfTheProduct: '是否取消该检品单',
    whetherToDiscardTheInspectionList: '是否废弃该检品单',
    Abandoned: '已取消废弃',
    onlyOneLogisticsNumberIsSupported: '暂只支持单个物流号',
    thereIsNoLogisticsNumberForThisProduct: '该商品没有物流号',
    ICouldntFindTheSamePackage: '没有找到同包裹的商品',
    pleaseSelectTheInspectorBeforeSubmitting: '请选中检品员后再进行提交',
    whetherToAssignTheInspectorToTheDeliveryOrder: '是否将该检品员调配至配送单',
    deploymentCancelled: '已取消调配',
    numberOfRemainingProductsToBeInspected: '剩余应检品数',
    numberOfNewInspectionOrders: '新检品单数量',
    TheNumberOfNewInspectionListShouldNotBeLargerThanTheNumberOfPreviousInspectionItems: '新检品单数量不能大于之前的应检品数',
    TheNumberOfNewInspectionOrdersShouldNotBeLessThanOrEqualTo0: '新检品单数量不能小于等于0',
    confirmTheSplit: '确认拆分',
    pleaseFillInTheNumberOfNewInspectionOrderBeforeSubmission: '请填写新检品单数量后再进行提交',
    whetherToSubmitPackageUnpacking: '是否提交包裹拆分',
    whetherToSubmitTheInspectionList: '是否提交该检品单',
    waitingForGoods: '待检品',
    testArticle: '检品',
    timeOfInspectionListSubmission: '检品单提出时间',
    inspectionFinishedTime: '检品完了时间',
    remarksOnInspectionList: '检品单备注',
    inspectionListStatus: '检品单状态',
    listOfGoods: '检品列表',
    badSummary: '不良汇总',
    badInspection: '不良検査',
    badMarkCode: '不良品コード',
    pleaseEnterBadMarkCode: '不良品コードを入力してください',
    badMarkCodeNotFound: '該当する不良品コードが見つかりません',
    problemState: '问题状态',
    problemConfirmed: '问题已确认',
    isProblemConfirmed: '是否问题已确认？',
    CheckList: '检品单',
    numberOfAdditionalServicesToBeProcessed: '待处理附加服务数量',
    itHasBeenConfirmedWhetherTheStatusOfTheItemHasBeenChangedToPoor: '是否将该商品状态变成不良已确认',
    theStatusModificationHasBeenCancelled: '已取消状态修改',
    pleaseFillInTheTransactionNumberOrLogisticsNumber: '请填写交易号或物流号',
    whetherToStartProcessingTheInspectionList: '是否开始处理该检品单',
    theActualNumberOfInspectionShouldNotBeGreaterThanTheQuantityOfInspection: '实检数不能大于应检品数',
    theNumberOfActualChecksCannotBeLessThan0: '实检数不能小于0',
    theNumberOfDefectsShouldNoBeGreaterThanTheNumberOfShouldBeInspected: '不良数不能大于应检品数',
    theNegativeNumberCannotBeGreaterThanTheActualNumber: '不良数不能大于实检数',
    theNegativeNumberCannotBeLessThan0: '不良数不能小于0',
    finishedGoods: '检品完了',
    whetherToKeepTheInspectionListTemporarily: '是否临时保存该检品单',
    theTemporarySaveHasBeenCancelled: '已取消临时保存',
    pleaseFirstChangeTheInspectionListStatusToStartProcessing: '请先将检品单状态改为开始处理',
    theParcelInformation: '包裹信息',
    toBeOn: '需上架',
    printTime: '打印时间',
    print: '打印',
    commodityNote: '商品备注',
    storesUp: '上架完了',
    awaitTranslated: '待翻译',
    toReply: '待客户回复 ',
    userReply: '客户回复 ',
    businessToProcessed: '待业务决策',
    businessDecisions: '业务决策',
    businessDecisionsRemark: '业务决策备注',
    purchaseToProcessed: '待采购处理',
    procurementProcess: '采购处理',
    procurementProcessRemark: '采购处理备注',
    distributionToProcessed: '待配货处理',
    distributionProcessed: '配货确认',
    accomplish: '完了',
    problemPic: '问题图片',
    problemNunber: '问题产品数',
    problemDescription: '具体问题描述',
    problemProductProposal: '问题产品提出',
    hasBeenShipped: '已出货',
    problemStatus: '问题状态 ',
    newAdditionalServices: '修改后附加服务',
    editAdditionalServices: '修改附加服务',
    problemPropose: '问题提出',
    poundage: '手续费',
    additionalServiceCharge: '附加服务费',
    editNumber: '修改后数量',
    editPrice: '修改后单价',
    editFreight: '修改后运费',
    procurementProcessRemark: '采购处理备注',
    confirmPayment: '确认付款？',
    porder: '配送依頼書',
    underwayPorder: '进行中的配送单',
    toEncasement: '待装箱',
    encasement: '装箱',
    encasementStatus: '装箱状态',
    toQuote: '待报价',
    toPayment: '支払い待ち',
    financialConfirmationCoTheAccount: '财务确认到账',
    businessShip: '业务出货',
    signFor: '签收',
    porderNumber: '配送依頼書No',
    porderStatus: '状態',
    porderSubmit: '配送单提交',
    porderTranslate: '配送单翻译',
    porderEncasement: '配送单装箱',
    porderQuote: '配送单报价',
    EuropeSignFor: '欧洲签收',
    userSignFor: '客户签收',
    porderProperty: '配送单属性',
    userSpecificMode: '客户指定方式',
    businessPorderRemark: '业务配送单备注',
    distributionPorderRemark: '配货配送单备注',
    porderRemark: '配送单备注',
    quotationDate: '报价完了',
    company: '会社名',
    zip_code: '邮编',
    address: '地址',
    contacts: '联系人',
    mobile: '携帯番号',
    tel: '电话',
    email: '电子邮箱',
    orderMash: '注文書No',
    boxed: '已装箱',
    putForwardNum: '提出数',
    forGoods: '商品费用',
    subtotal: '小计',
    warehouseNumber: '倉庫数量',
    quantityOfGoodsUsedInStock: '库存商品使用数量',
    warehouse: '倉庫',
    packingCase: '装箱情况',
    finishPacking: '装箱完了',
    finishPackingCancel: '装箱完了取消',
    totalWeights: '合计重量',
    wayToSend: '发送方式',
    modeOfDespatch: '发货方式',
    addBox: '添加箱子',
    delBox: '删除箱子',
    editBox: '修改箱规毛重',
    printPackingList: '打印装箱单',
    printingMarks: '打印唛头',
    submissionToBusiness: '提交给业务',
    isSubmissionToBusiness: '确认提交给业务？',
    importer: '进口商信息',
    receive: '收件人信息',
    customerDeliveryNotes: '客户配送单备注',
    customerDeliveryNotesTranslation: '客户配送单备注翻译',
    otherFees: '其他费用',
    otherFeesEdit: '其他费用编辑',
    otherFeesRemark: '其他费用备注',
    tariffs: '关税',
    estimateInternationalCosts: '预估国际费用',
    customerDesignatedShippingCompany: '客户指定运公司',
    customsClearanceWay: '通关方式',
    nowRate: '今日汇率',
    internationalFees: '国际费用',
    boxNumber: '箱子数',
    boxRoughWeight: '箱子毛重',
    boxPile: '箱型',
    length: '长',
    width: '宽',
    height: '高',
    boxDetail: '箱子详情',
    freightNum: '本箱已装箱数',
    otherBoxNum: '其他已装箱数',
    movingGoodsBox: '商品移箱 ',
    movingGoodsNum: '移箱数',
    quantityOfGoodsUsedInStock: '库存商品数',
    okEncasement: '确定装箱?',
    isEncasementCancel: '确定取消装箱完了?',
    submitDeliverer: '提交给配货员',
    isSubmitDeliverer: '确认提交给配货员？',
    returnDelivery: '退回给配货',
    isReturnDelivery: '确认退回给配货？',
    returnToBeQuoted: '退回待报价',
    isReturnToBeQuoted: '确认退回待报价？',
    backToNotPay: '退回待入金',
    isBackToNotPay: '确认退回待入金？',
    quotationCustomer: '给客户报价',
    isQuotationCustomer: '确认给客户报价？',
    presentBoxNum: '当前箱号',
    personalCustomsClearance: '个人通关',
    personalCustomsCompany: '代通关',
    encasementInterface: '装箱界面',
    selectBoxNum: '当前选中箱数 ',
    selectBoxes: '选中箱号',
    oneCasePack: '每一箱装箱数',
    boxNum: '箱数',
    internationalDeliveryInformation: '国际派送信息',
    loadingTime: '装柜完了时间',
    loading: '装柜完了',
    isLoading: '确认装柜完了？',
    dateOfShipment: '货运出货日期  ',
    feedbackTime: '提单反馈时间  ',
    customsTlearanceTime: '通关时间  ',
    spainTheDeliverTime: '西班牙发货时间',
    deliveryTime: '发货时间',
    spainSendsMessages: '西班牙派送信息 ',
    spainSendsMessagesEdit: '西班牙派送信息编辑',
    domesticDeliveryCostsInSpain: '西班牙国内派送费用',
    forBooking: '待订舱 ',
    haveBooking: '已订舱待回复 ',
    theContainer: '待装柜 ',
    shippedOut: '出货完了',
    booking: '订舱 ',
    packingListInvoice: '箱单发票',
    setTheTank: '定舱',
    destination: '目的地 ',
    bookingVolume: '订舱体积m3',
    deliveryOrder: '配送单出货',
    containerCancel: '取消订舱',
    cabinetCancel: '取消装柜',
    isContainerCancel: '确认取消订舱？',
    iscontainerCompleteBack: '确认取消装柜完了？',
    positionOk: '船位已确定',
    BookingTime: '订舱时间',
    destinationPor: '目的港',
    theBillOfLadingToUpload: '提单上传',
    theBillOfLadingToDownload: '提单下载',
    theBillOfLadingToDocuments: '提单文件',
    packingListInvoiceDownload: '箱单发票下载',
    invoice: '发票',
    delivery: '派送中',
    internationalDeliveryIsUnderway: '国际派送中',
    haveCustomsClearance: '已通关',
    isHaveCustomsClearance: '确认整个单号的配送单都将通关完了？',
    daiQianShou: '待客户签收',
    spanishDelivery: '西班牙派送',
    SpanishLogistics: '西班牙物流号',
    received: '受領済み',
    thisCaseNum: '本箱装箱数',
    moveFreightGoods: '确认移箱',
    moveTheBoxNumber: '需移到选中箱子的商品数',
    selectTheSendingMode: '选择发送方式',
    guiLei1688: '1688归类',
    currentBalance: '当前余额:',
    mentionOrder: '提订单',
    mentionDistribution: '提配送单:',
    orderPaymentAuthorization: '订单入金授权:',
    distributionPaymentAuthorization: '配送单入金授权:',
    customerMarks: ' 客户唛头:',
    unauthorized: '未許可',
    haveAuthorized: '許可済み',
    authorized: '操作許可',
    noAuthorized: '未許可',
    chatTools: '聊天工具:',
    customerRelatedOperationFunctions: '客户相关操作功能 ',
    customerAttributeIdentification: '客户属性标识',
    customerProperty: '会員分類',
    customerShippingMarkSetting: '客户唛头设置',
    chatSettings: '聊天工具设置 ',
    authorizationSettings: '授权设置',
    deliveryToEntrust: '发货委托 ',
    allOrder: '全部订单',
    quotedPrices: '报价中',
    waitingPayment: '支払い待ち',
    problemOfGoods: '问题商品',
    freightQuoted: '运费报价中',
    freightToBePaid: '运费待付款 ',
    index: '主页',
    orderManagement: '注文管理',
    deliveryOrderBeforeShipment: '出货前配送单 ',
    internationalTransport: '国际运输中',
    moneyManagement: '资金管理 ',
    entryAndExitDetails: '出入金明细',
    afterSaleConfirmationMethod: 'アフターサービスの確認方法を選択してください',
    completeDirectly: 'そのまま完了',
    directCompleteDescription: '説明',
    directCompleteDescriptionPlaceholder: '直接完了の説明を入力してください',
    directCompleteProof: '証憑',
    uploadProof: '証憑をアップロード',
    directCompleteRequirement: '説明または証憑のいずれかが必須です。証憑は最大8ファイルまで、種類とサイズの制限はありません。',
    directCompleteRequired: '説明を入力するか、証憑をアップロードしてください',
    directCompleteProofLimit: '証憑は最大8ファイルまでアップロードできます',
    proofUploadFailed: '証憑のアップロードに失敗しました。もう一度お試しください',
    entryAndExitPreview: '入出金プレビュー',
    customerInternalManagement: '客户内部管理',
    notesForCustomers: '会員注意事項 ',
    mattersNeedingAttention: '注意事项 ',
    wuliuMattersNeedingAttention: '1、区间表示大于左边,小于等于右边 结束值不填默认为上限无穷大',
    IsBuying: '正在购买',
    canceled: 'キャンセル',
    proposedDate: '提出日',
    paymentDate: '支払い日',
    purchaseCompletionDate: '買付完了日',
    remark: '备注',
    product: '产品',
    shop: '店铺',
    totalPrice: '总价',
    commodityTotalPrice: '商品总价值',
    putForward: '提出',
    addCommodity: '追加商品',
    numberTotabl: '数量总计',
    items: '商品种类',
    allExpenses: '全部的费用',
    productValue: '产品价值',
    chooseAnInternationalCarrier: '选择国际运输公司',
    balancePayment: '余额支付',
    estimatedOrderAmount: '预计订单金额',
    useOoupons: '使用优惠券',
    accountBalanceAfterPayment: '付款后账户剩余',
    actualAmountPaid: '实际支付金额',
    pay: '支付',
    paySuccess: '支付成功',
    paymentRransactionNumber: '付款交易号',
    returnListInterface: '返回列表界面',
    putForwardDeliveryOrder: '見積り提出',
    canBePutForward: '可提出',
    thePacking: '梱包中',
    quantityAvailableForDelivery: '可提货数量',
    quantityAvailableDelivery: '提货数量',
    priceYuan: '单价(元)',
    purchaseQuantity: '购入数量',
    rakumartPersonalCustomsCompany: 'rakumart代通关',
    appendDeliverylist: '追加到配送单',
    allDelivery: '全部配送单',
    BillingWeight: '计费重量(kg)',
    InternationalLogisticsFee: '国际物流费用(€)',
    hasHeenShipped: '発送済み',
    toHeenShipped: '待发货',
    isPorderBalancePayment: '确认给配送单付款？',
    haveSustomsClearance: '已清关',
    SpanishDeliveryInProgress: '西班牙派送中',
    clientReceive: '签收',
    isClientReceive: '确认签收配送单？',
    keyword: '关键词',
    transactionType: '交易类型',
    transactionWay: '交易方式',
    financialConfirmationDate: '日期(财务确认日期)',
    time: '日期',
    theDetail: '明细',
    amountChange: '金额变动',
    parcelSearch: '包裹搜索',
    courierNumber: '快递单号 ',
    entry: '录入 ',
    packageScanning: '包裹扫描',
    signer: '收件',
    noAccountPayable: '应付款不能小于0',
    NoUser: '未匹配到相对应的id的客户',
    danGeDanDingDan: '问题产品提出需要限制单次只能单个订单的商品一起提出问题产品',
    cancelAllChecked: '取消全选',
    problemStoreEooro: '存在待财务付款状态的商品，不能提出问题产品。请取消待财务付款后在提问题产品',
    EstimatedTotalVolumeOfGoods: '预计商品总体积',
    EstimatedWeight: '预计重量',
    AntiDumpingDuties: '反倾销税',
    TheVAT: '增值税',
    Problem: '问题产品',
    preSaleProblem: '售后问题',
    adjust: '出入金',
    adjustList: '出入金列表',
    submitTime: '提交时间',
    adjustReason: '内部调整原因 ',
    categorySelection: '类别选择 ',
    notesForCustomersToSee: '给客户看的备注(西班牙文)',
    customerScreenshots: '客户联系截图',
    adjustTheType: '调整类型',
    specificCauseRemarks: '具体原因备注',
    PackingVolume: '装箱体积',
    relatedTransactionNumber: '关联交易号 ',
    packageSearchForm: '包裹搜索表单',
    domesticReturn: '国内退件',
    signForMember: '签收员',
    logisticsFollow: '物流货运跟进',
    offline_wait: '待线下提货',
    addOfflinePickup: '添加线下提货',
    registrationTime: '登记时间',
    peoplePutForward: '提出人',
    jianShu: '件数',
    RMBfreightCost: '运费.元',
    pickUpContactInformation: '提货联系人信息',
    AddressRemarks: '地址、备注',
    deliveryContact: '提货联系人',
    deliveryContactPhone: '提货联系人电话',
    TheRequired: '此项为必填项',
    theGoods: '收货',
    receivingEndOfaSingle: '收货底单',
    transferRecord: '转账记录',
    goodsTakenForConfirmation: '已提货待确认',
    deliveryConfirm: '提货已确认',
    goodsTime: '收货时间',
    returnForPickup: '退回待提货',
    confirmBackReturnForPickup: '确认退回待提货？',
    submitOne: '提交人',
    expressNo: '快递号',
    signForPeople: '签收人',
    urgent: '紧急件',
    pendienteDeFirma: '待签收',
    noticeList: '通知列表',
    notice: '通知',
    title: '标题',
    content: '内容',
    sendTime: '发送日期',
    alerts: '发布通告',
    noticeGroup: '通告群体',
    Announcements: '通知公告',
    personnelSelection: '人员选择',
    noticeContent: '通知内容',
    noticeTitle: '通知标题',
    noticeLook: '通知预览',
    preview: '预览',
    areYouSureToNotice: '请再次确认是否发送通知，通知一经发送无法取消',
    adminNoticeList: '通知列表',
    noticeDelete: "当前选择的通知中，包含有未读的通知，是否确认删除选中的内容。",
    directBusinessCompletion: '业务直接完成',
    confirmdirectBusinessCompletion: '确认业务直接完成?',
    backlog: '待修改',
    modified: '已修改',
    BulkChanges: '批量修改',
    BatchConfirmation: '一括確認',
    GoogleAutomaticallyTranslatesTheResults: '谷歌自动翻译结果',
    ManuallyModifyKeywords: '人工修改关键词',
    SearchResultsInterface: '搜索结果界面',
    look: '查看',
    lookDetail: '查看详情',
    editName: '修改人',
    editTime: '修改时间',
    SearchKeywordModification: '搜索关键词修改',
    ProductSpecificationsKeywordMaintenance: '商品规格关键词维护',
    ManualSearchKeywordMaintenance: '商品属性翻译维护',
    KeywordMaintenance: '关键词翻译维护',
    WordsEnteredByTheCustomer: '客户输入的词',
    ArtificialKeywordsBatchModification: '人工关键词批量修改',
    Modificaçãomanualdepropriedadesespanholas: '人工修改西班牙语属性',
    ToFindTheContent: '查找内容',
    AlternativeContent: '替换内容',
    confirm: '確定',
    FillChineseValues: '填充中文值',
    FillTranslationValue: '填充翻译值',
    goodsQualityCacheClear: '清除商品缓存',
    isGoodsQualityCacheClear: '请确保本次批量修改已全部完成，缓存清除后客户首次打开商品界面会很慢，谨慎作此操作',
    web_img: 'pc版主图',
    default_back_color: '默认背景颜色',
    trigger_back_color: '触发时背景颜色',
    orderSubmissionTime: '订单提交时间',
    orderType: '订单类别',
    originalOrder: '原订单',
    amountOfOrderYuan: '订单金额.元',
    orderPropertyEditing: '订单属性编辑',
    orderRemarksEditing: '订单备注编辑',
    orderAdjust: '订单调整',
    transactionNumberStatus: '交易号状态',
    financialPaymentIsUrgent: '待财务付款紧急',
    waitingForChangePrice: '等待改价',
    orderInformation: '注文番号',
    currentOrderInformation: '当前订单信息',
    deleted: '已删除',
    customerOrdersCommodityAttributes: '客户下单商品属性',
    userNum: '客户数量',
    userOriginalPrice: '客户原价',
    businessEditAttributes: '业务编辑属性',
    confirmPurchasePrice: '实际采购价',
    singleItemSize: '单个商品尺寸.cm',
    individualWeight: '单个重量.kg',
    tagNumber: '标签编号',
    tagOperation: '标签操作',
    codeCopyToText: '编码复制到文本',
    addMadeInChina: '新增Made in China',
    orderLastFour: '注文番号の末尾4桁',
    orderLastFourAddFailed: '注文番号の末尾4桁の追加に失敗しました',
    batchModifyBarcodeFormat: '批量修改条码格式',
    orderTagDeleteUnavailable: '订单标签删除接口暂未提供',
    orderTagDeleteSuccess: 'タグを削除しました',
    orderTagDeleteFailed: 'タグの削除に失敗しました',
    madeInChinaAddFailed: 'Made in China の追加に失敗しました',
    clearMatchDataFailed: 'マッチングデータのクリアに失敗しました',
    batchModifyCodeTypeFailed: 'バーコード形式の一括変更に失敗しました',
    codeCopyToTextFailed: '商品コードのテキストコピーに失敗しました',
    tagMatchingFailed: 'ラベル照合に失敗しました',
    orderTagPrintFailed: 'ラベルの印刷状態の更新に失敗しました',
    orderTagPrintReasonFailed: '印刷理由の登録に失敗しました',
    quoteInLibraryNumber: '报价在库数',
    productSpecifications: '商品规格',
    alternative: '备选',
    size: '尺寸',
    weight: '重量',
    commodityMonitoringEntry: '商品监控录入',
    obtainStoreInformation: '获取店铺信息',
    additional: '追加',
    customersAddAttachments: '客户添加附件',
    propertyEditForm: '属性编辑表单',
    websitePropertySelection: '网站属性选择',
    manuallyEditProperties: '人工编辑属性',
    attributeName: '属性名称',
    specificAttributeValue: '具体属性值',
    regularOrders: '普通订单',
    forwardOrders: '转寄订单',
    takeSampleOrders: '拿样订单',
    AccessorieOrder: '辅料订单',
    additionalServiceOptions: '附加服务选择',
    internationalFreightEstimate: '国际运费预估',
    totalVolumes: '总体积',
    totalWeight: '总重量',
    orderTypeEditing: '订单类型编辑',
    surveyOfFreight: '调查运费',
    LogisticsAdditionalServiceMaintenance: '附加服务维护',
    sortNumberSetting: '排序编号设置',
    accountingRules: '计费规则',
    defaultChargeRate: '默认收费标准',
    problemProductsAreAutomaticallyCalculated: '问题产品自动计算',
    systemNumber: '系统编号',
    optionNnitPriceQuantity: 'option单价*数量 ',
    unitpriceofgoodsPercentage: '商品单价*百分比 ',
    automaticCalculation: '自动计算',
    artificialCalculation: '人工计算',
    noAutomaticCalculation: '不自动计算',
    units: '单位',
    internationalLogisticsMaintenance: '国际物流维护',
    activeElementSettingsInRealTime: '实时生效元素设置',
    theLogisticsTrackingNumberIsAutomaticallyObtained: '物流单号自动获取',
    customerOrderSelectionPrompt: '客户订单选择提示',
    setThemRoughly: '号段设置',
    promptMessageSetting: '提示语设置',
    addedManualQuotationRules: '新增人工报价规则',
    editdManualQuotationRules: '编辑人工报价规则',
    addedAutomaticQuotationRule: '新增自动报价规则',
    editAutomaticQuotationRule: '编辑自动报价规则',
    daysOfAutomaticReceipt: '自动签收天数',
    takeTheWholeRange: '取整区间',
    priceRange: '价格区间',
    thatSet: '说明设置',
    japaneseDescriptionSettings: '日文说明设置',
    EnglishDescriptionSettings: '中文说明设置',
    setTheLogisticsTrackingNumberAutomatically: '物流单号自动获取设置',
    themRoughlyRules: '号段规则',
    availableQuantity: '可用数量',
    prefix: '前缀',
    startSingleNumber: '开始单号',
    singleNumber: '截止单号',
    promptMessageSetting: '提示语设置',
    effectiveDate: '生效日期',
    billingWay: '计费方式',
    singleTransmissionMode: '单发送方式',
    accumulatesAfterChargingForASingleBox: '单箱计费后累加',
    valuationType: '计价类型',
    meterBehindWay: '计抛方式',
    takeTheWholeOrder: '取整顺序',
    takeTheFirst: '先取整',
    afterTheWhole: '后取整',
    singleBox: '单箱',
    theTicket: '整票',
    castHeavyProportion: '抛重比例',
    whetherToCountHalfCast: '是否计半抛',
    TheWeightVolumeIsRounded: '重量/体积取整区间',
    pricingInterval: '计价区间',
    additionalCharge: '额外收费',
    whetherToReturnToGold: '是否回退待入金?',
    directPayments: '直接付款',
    whetherToConfirmDirectPayment: '是否确定直接付款？',
    generatingTaobaoOrders: '生成淘宝订单',
    markThePriceToBeChanged: '标记待改价',
    theStatusIsWrongPleaseRefreshAndTryAgain: '状态有误, 请刷新重试!',
    customerAfterPaymentQuantity: '客户付款后数量',
    customerAfterPaymentOrder: '客户付款后订单',
    customerAfterPaymentPrice: '客户付款后价格',
    transactionNumberLogisticsNumber: '交易号/物流号',
    customerOrderDetails: '客户下单详情',
    originalTransactionNumber: '原交易号',
    numberOfOriginalTransactionNumbers: '原交易号数量',
    newTransactionNumber: '新交易号',
    numberOfNewTransactionNumbers: '新交易号数量',
    residualAfterSplit: '拆分后剩余',
    productDescriptionInChineses: '中文商品描述',
    defaultInformationSource: '默认信息来源',
    domesticReturnScan: '国内退件扫描',
    scanningParcel: '包裹扫描',
    followUpTheReplacementPackage: '换货包裹跟进',
    returnAndExchangeLogistics: '退换货物流跟进',
    printFaceSheet: '待打印面单',
    SignInScan: '签收已扫描',
    returnScan: '退件待扫描',
    toBePacked: '返品・交換記録',
    toBePackedStatus: '梱包待ち',
    packingStatus: '梱包状態',
    returnAndExchangeNumber: '退换货编号',
    typeOfReturnOrExchange: '退换货类别',
    quantityOfReturnAndReplacement: '退换货数量',
    detailsOfGoods: '商品明细',
    returnAndExchangeLogisticsNumber: '退换货物流号',
    refundLogisticsNumber: '返品物流番号',
    packedUp: '已打包',
    pack: '打包',
    possibleNumberOfShelves: '上架可能数',
    claimAParcel: '待认领包裹',
    haveBeenClaimed: '已认领包裹',
    site: '站点',
    personOfRegistration: '登记人',
    pictureOfPackage: '包裹图片',
    toClaim: '认领',
    packageAddition: '包裹新增',
    packageEdit: '包裹编辑',
    personOfClaim: '认领人',
    returnToBeClaimed: '退回待认领',
    printTheShippingMark: '打印包裹唛头',
    signAndNoteThePicture: '签收备注图片',
    remarksOfSigner: '签收员备注',
    emergencyItems: '紧急件',
    remarksOfProposer: '提出人备注',
    urgentItemsAdded: '紧急件新增',
    returnAndExchangeEditor: '退换货编辑器',
    typeOfReturnOrExchange: '退换货类别',
    checkCommodityFollowUp: '核查商品跟进',
    wholeRoundQuantity: '整番数量',
    numberOfTransactionNumbers: '交易号数量',
    underCheck: '核查中',
    onTheShelf: '上架中',
    last5DigitsOfTheOrderNumber: '订单号后5位',
    putOnStoreShelves: '上架入库',
    directPacking: '直接装箱',
    addTheGeneralInspectionList: '添加普检单',
    addTheQualityCheckSheet: '添加精检单',
    startChecking: '开始核查',
    printCustomerInformation: '打印客户信息',
    theCurrentOrderIsInBox: '当前订单装箱中',
    theCurrentOrderHasBeenBoxed: '当前订单已装箱',
    otherOrdersAreInBoxes: '其他订单装箱中',
    otherOrdersHaveBeenBoxed: '其他订单已装箱',
    addNewChest: '添加新箱子',
    boxGaugeModification: '箱规修改',
    modificationOfWeigh: '重量修改',
    cancellationOfPacking: '取消已装箱',
    markPackingFinished: '标记装箱完了',
    numberOfBoxes: '箱子数量',
    aBoxWithNoSelectedOperation: '未选择操作的箱子',
    areYouSureTheMarksArePackedProperly: '是否确定标记装箱完了？',
    areYouSureToReturnAfterPacking: '是否确定装箱完了回退？',
    putForwardTheQuantityToBePacked: '提出待装箱数量',
    remainingNumberToBePacked: '剩余待装箱数',
    boxNO: '箱号',
    quantityOfCargoInThisCase: '本箱装货数',
    priceY: '价格.元',
    cancelTheBox: '取消箱子',
    takeOutGoods: '取出商品',
    whetherToTakeOutTheGoods: '是否取出商品？',
    saveThePackingListInformation: '保存装箱单信息',
    weightFillingBar: '重量填写栏',
    boxRemarks: '箱子备注',
    boxRemarksEdit: '箱子备注编辑',
    temporaryStorageLocation: '临时库位',
    goodsNeedToBeMoved: '需要移箱商品',
    confirmationOfBoxMoving: '确认移箱',
    numberOfOtherBoxesPacked: '其他箱已装箱数',
    abandonedGoods: '废弃商品申请',
    cleanUpGoods: '清理商品',
    warehouseLocationManagement: '库位管理',
    areaSettings: '区域设置',
    inventoryDetails: '库存详情',
    allAreas: '全部区域',
    inUse: '使用中',
    disable: '停用',
    areaNumber: '区域编号',
    regionalUsageSetting: '区域用途设置',
    building: '楼栋',
    element: '站点',
    floor: '楼层',
    areaSizeM: '区域尺寸(米)',
    regionalUse: '区域用途',
    numberOfAreaDatabaseLocations: '区域库位个数',
    areaDescription: '区域描述',
    statusOfUse: '使用状态',
    buildingWhereTheRegionIsLocated: '区域所在楼栋：',
    unitOfTheRegion: '站点：',
    floorOfTheArea: '区域所在楼层：',
    subdivisionAreaUse: '细分区域用途',
    regionalUsageCode: '区域用途编码',
    regionalUsageCodeTip: '区域用途设置新增区域编码打印展示，后续会经常修改',
    addType: '添加类别',
    inAreaNumber: '所在区域编号',
    categoryOfShelves: '货架类别',
    shelfSizeMeters: ' 货架尺寸.米',
    shelfLayerNumber: '货架层数',
    numberOfLibraryBitsPerLayer: '每层库位数',
    shelfNumber: '货架编号',
    rangeOfUseOfShelf: '货架使用范围',
    managementPersonnel: '管理人员',
    remarksOnShelves: '货架备注',
    batchOpen: '批量开启',
    batchClose: '批量关闭',
    batchCreateSystemShelf: '批量创建系统货架',
    createShelfCount: '创建货架个数',
    creating: '作成中',
    setShelfUser: '设置货架使用人',
    batchSetShelfUser: '批量设置货架使用人',
    userAttribute: '使用人属性',
    specificRange: '具体范围',
    shelfUserRangeTip: '设置货架使用人，只能修改货架的使用人属性以及具体范围。属性为公共货架时范围展示组织，属性为个人货架时范围展示人员。具体范围只展示当前账号层级下的组织与人员。',
    owningRegion: '所属区域',
    scopeOfUse: '使用范围',
    publicShelf: '公共货架',
    personalShelf: '个人货架',
    specificPersonnel: '全体',
    typeOfProblem: '问题类别',
    problemSolving: '问题处理',
    pre_saleProblem: '售前问题',
    amountAfterGol: '入金后数量',
    amountAfterGol: '入金后数量',
    generalGoodsWarehouse: '常规商品仓库',
    sparePartsWarehouse: '备品仓库',
    auxiliaryMaterialsWarehouse: '辅料仓库',
    chargeWarehouse: '課金倉庫',
    inAbout30Days: '近30天上架完',
    itWentOnTheShelves30DaysAgo: '30天前上架完',
    goodsID: '商品ID',
    timeOfPayment: '入金时间',
    timeType: '时间类型',
    petitionForAbandonment: '申请废弃',
    moveTheLibrary: '移库',
    export: '导出',
    remove: '清除',
    isRemove: '是否清除选中的商品？',
    returnTheBoxedList: '退回已装箱列表',
    location: '库位',
    remarksOfSubdivisionRegion: '细分区域备注',
    timeOfStorage: '入库时间',
    outOfShelfTime: '上架完了时间',
    timeOfPackingFinished: '装箱完了时间',
    numberOfLibraryPositions: '库位数',
    orderOperato: '订单操作人员',
    boxGauge: '箱规(cm)',
    serviceBoxRemarks: '业务箱子备注',
    daysOfCharging: '计费天数',
    expensesIncurred: ' 已产生费用(元)',
    wasteGoods: '商品废弃',
    packingInformation: '装箱信息',
    attributeOfAuthorization: '授权属性',
    type: '类型',
    numberOfStorageLocations: '库位数量',
    quantityOfWaste: '废弃数量',
    actualQuantityOfSparePart: '实有备品数量',
    contactScreenshot: '联系截图',
    remarksOnReasonsForTransfer: '转入原因备注',
    pendingApprova: '待审批',
    approvedAndApproved: '已审批',
    Deleted: '已删除',
    serviceRemarks: '业务备注',
    distributionRemarks: '配货备注',
    personalArea: '个人区域',
    commonArea: '公共区域',
    warehouseGoods: '库位商品',
    numberOfInventory: '库存数',
    theApplicant: '申请人',
    times: '时间',
    applicationReasonRemarks: '申请原因备注',
    numberOfLibraryPosition: '库位数',
    numberOfWaste: '废弃数',
    numberOfActualNumbers: '实有数',
    isTheApprovalConfirmed: '确定审批通过？',
    cleanUpTime: '清理时间',
    quantityOfClearance: '清理数量',
    theCleaner: '清理人',
    packingTimeDB: '打包时间',
    quantityOfWarehouseTransfer: '移库数量',
    whetherToConfirmThePackage: '是否确认打包?',
    entryOfLogisticsBillNumber: '物流单号录入',
    returnToPrint: '退回待打印',
    isReturnToPrint: '是否确定退回待打印？',
    returnScanTime: '退件扫描时间',
    editTheReturnNumber: '返件单号编辑',
    returnNumber: '返件单号',
    returnTrackingNumber_Status: '返件单号-状态',
    addTheReturnTrackingNumber: '添加返件单号',
    addReplacementReturnTrackingNumber: '交換返送追跡番号を追加',
    returnAndExchangeFollowUp: '返品・交換フォロー',
    waitForTheSellerToReturnTheGoods: '等待卖家返件',
    replacementPackageToBeSigned: '换货包裹待签收',
    theReplacementPackageHasBeenReceived: '换货包裹已签收',
    theReplacementIsCancelled: '取消换货',
    isTheReplacementIsCancelled: '是否确定换货取消？',
    summaryOfBadPerformanc: '不良汇总',
    problemToBeConfirmed: '检品完了待确认不良',
    theTemporaryInspectionIsDefective: '临时检品待确认不良',
    theBusinessEditsTheCommodityProperties: '业务编辑商品属性',
    numberOfGeneralTestprecisionTestProblems: '普检/精检问题数',
    numberOfLabelLayoutProblems: '布标问题数',
    finalQuantity: '最终数量',
    finalUnitPrice: '最终单价',
    finalFreightRate: '最终运费',
    whetherPerformanceNeedsToBeCalculated: '是否需要计算绩效',
    generalInspectionReinspectionList: '普检复检单',
    fineRetestList: '精检复检单',
    numberOfGoodsToBeReinspected: '需复检商品数',
    theNumberOfGeneralprecisionTests: '普/精检实检数',
    generalqualityInspectionQuantityIsPoor: '普/精检数量差',
    theNumberOfBadSpermatologicalTests: '普/精检不良数',
    clothLabelFeedbackIsPoor: '布标反馈不良',
    orderData: '下单数据',
    goodsToBeInspected: '应检品',
    temporarilyPutForwardDefectiveGoods: '临时提出检品不良',
    submitTheClothLabelForProcessing: '提交布标处理',
    theClothLabelIsFinished: '布标处理完了',
    numberOfLabelsToBeLaid: '待布标处理数',
    quantityOfClothLabelProcessing: '布标处理数量',
    theQuantityOfClothProcessingIsPoor: '布标处理数量差',
    numberOfDefectiveClothLabels: '布标不良数',
    numberOfGeneralprecisionTestProblems: '普/精检问题数',
    quantityPriceFreightModification: '数量价格运费修改',
    calculateTheDataAfterModification: '修改后数据计算',
    productReturnAndExchange: '产品退换货',
    quantityPriceFreightModification: '数量价格运费修改',
    rehashTheProblemProduct: '重提问题产品',
    problemProductCancellation: '问题产品取消',
    isProblemProductCancellation: '确认问题产品取消？',
    returnToPendingBusinessDecision: '退回待业务决策',
    isReturnToPendingBusinessDecision: '确认退回待业务决策？',
    priceAfterEntryIntoGold: '入金后价格',
    modifiedData: '修改后数据',
    temporaryRemarks: '临时备注',
    porderType: '配送单类别',
    deliveryOrderSubmissionTime: '配送单提交时间',
    formOfShipment: '出货形式',
    numberOfWords: '番数',
    associateASuborderNumber: '关联子单号',
    modifyTheStatus: '修改状态',
    consolidationOfDistributionOrder: '配送单合并',
    porderLengthPrompt: '选择的配送单需要大于等于2个',
    consolidationOfDistributionOrderPrompt: '配送单合并完成之后，将删除合并的配送单，生成新的配送单。',
    clearFBAData: '清空FBA数据',
    identificationFBA: '标识FBA',
    cancelTheFBAIdentifier: '取消贴标标识',
    isCancelTheFBAIdentifier: '确定取消FBA标识？',
    generalDistributionList: '普通配送单',
    fBADeliveryOrder: 'FBA配送单',
    shippingOrdersAndShippingOrders: '配送单并单出货',
    fBAOperation: 'FBA操作',
    numberOfTagMatches: '标签匹配数量',
    labelNo: '标签号',
    commodityCode: '商品码',
    numberOfLabels: '标签数量',
    editAndModify: '编辑修改',
    complete: '完成',
    confirmProcessingIsComplete: '确认处理完成',
    commitChanges: '提交修改',
    intoGeneralStorage: '入普通仓库',
    intoChargeWarehouse: '入收费仓库',
    returnToContainer: '退回装箱中',
    generateDeliveryOrder: '生成配送单',
    isGenerateDeliveryOrder: '确认生成配送单？',
    boxNo: '箱子编号',
    packingTime: '装箱时间',
    stateOfTheBox: '箱子状态',
    currentOrderStatus: '当前订单状态',
    orderNotShipped: '未出货订单',
    updateTime: '更新时间',
    notesOnPackingOfGoods: '配货装箱备注',
    salesmanPackingNotes: '业务员装箱备注',
    markingAndLabeling: '标识贴标',
    isMarkingAndLabeling: '确认标识贴标？',
    orderToBePacked: '配货单待装箱',
    deliveryOrderToBeQuoted: '配送单待报价',
    deliveryOrderToBePaid: '配送单待支付',
    deliveryOrderToBeShipped: '配送单待出货',
    invoiceItemNameEditing: '发票品名编辑',
    associateTheSubDeliverySingleNumber: '关联子配送单单号',
    distributionOrderSplitting: '配送单拆分',
    labelNumberAdd: '新建标签',
    tagMatching: '标签匹配',
    submitToDistribution: '提交给配货',
    attachment: '附件',
    rate: '汇率',
    detailsOfOtherExpenses: '其他费用明细',
    internationalFreight: '国际运费',
    theCustomerSpecifiesTheSendingMode: '客户指定发送方式',
    serviceSelectTheSendingMode: '业务选择发送方式',
    numberOfLabels: '标签数量',
    numberOfTags: '标签数',
    tagMatchingNumber: '标签匹配数',
    titleEditor: '品名编辑',
    shippingListPackingDetailsDownload: '配送单装箱明细下载',
    shippingListPackingDetailsLook: '配送单装箱明细查看',
    detail: '详细',
    libraryLocationInformation: '库位信息',
    splitToNewDeliverySingular: '拆分到新配送单数',
    surplusQuantity: '剩余数量',
    returnToTranslation: '退回待翻译',
    unpack: '取消装箱',
    actualWeightS: '实重',
    packingNumber: '装箱数',
    takeItOutToASpecificTransactionNumber: '取出到具体交易号数量',
    internationalFreightCalculation: '计算国际运费',
    sendingModeSelection: '发送方式选择',
    theBoxesAreSplitIntoTheNewDeliveryOrder: '箱子拆分到新配送单',
    uploadActualDeliveryNumber: '上传实际纳品数',
    selectEachBoxForInternationalFreightReference: '选中各箱国际运费参考',
    totalNumberOfBoxesDelivered: '配送单总箱数',
    numberOfBoxesCurrentlySelected: '当前选中箱数',
    billingData: '计费数据',
    totalRealWeight: '合计实重',
    totalWeightPao: '合计抛重',
    specificSendingMode: '具体发送方式',
    chargeType: '收费类别',
    nominalCharge: '收费名义',
    theAmountChargedYuan: '收费金额.元',
    theAmountChargedRi: '收费金额.円',
    otherChargesForTheSpecificDeliveryMethodOfTheDeliveryOrder: '配送单具体发送方式其他费用',
    selectTheItemWithTheSameID: '选中同ID商品',
    productDescriptionInChinese: '商品中文描述',
    labelNumberEditing: '标签编号编辑',
    codingRule: '编码规则',
    labelCommodityManagementCode: '标签商品管理编码',
    labelDisplayContent: '标签显示内容',
    displaySequence: '显示顺序',
    contentCategory: '内容类别',
    specificContent: '具体内容',
    tagType: '标签类别',
    requotationOfDeliveryOrder: '配送单重新报价',
    internationalLogisticsDistributionIsProposed: '国际物流配送提出',
    isInternationalLogisticsDistributionIsProposed: '确定国际物流配送提出？',
    fillInTheLogisticsNumberInBatches: '批量填写物流单号',
    obtainTheLogisticsTrackingNumber: '获取物流单号',
    serviceShippingMarkPrint: '业务唛头打印',
    printedSheet: '面单打印',
    fillInTheLogisticsOrderNumberInBatch: '批量填写物流单号',
    numberOfBoxesSelected: '选中箱数',
    afterSale: '售后',
    statusOfLogisticsOrderNumber: '物流单号状态',
    invoiceStatus: '发票状态',
    shippingMarkStatus: '唛头状态',
    invoiceEditingInterface: '发票编辑界面',
    packingDetails: '装箱数据明细',
    summaryOfCurrentInvoiceInformation: '当前发票信息概况',
    currentDate: '当前日期',
    meterThrowRatio: '计抛比例',
    deliveryListNumber: '配送单箱号',
    throwWeight: '抛重',
    senderInformation: '发件人信息',
    companyName: '公司名称',
    originatingAddress: '发件地址',
    contactNumber: '联系电话',
    commodityInformation: '商品信息',
    JapaneseName: '日语品名',
    SubtotalYen: '小计(日元)',
    Subtotal$: '小计(美元)',
    SubtotalRMB: '小计(RMB)',
    SubtotalYuan: '小计(元))',
    productNameEditor: '商品品名编辑',
    finishedSaving: '保存完了',
    invoiceFormDownload: '发票表格下载',
    invoiceInitialization: '发票初始化',
    isInvoiceInitialization: '是否确定发票初始化？',
    japaneseMaterial: '日语材质',
    chineseName: '中文品名',
    chineseProductDescription: '中文商品描述',
    commodityCode: '商品编码',
    customerSellingStoreInformation: '客户售卖店铺信息',
    automaticallyGenerateTraffickedLinks: '自动生成贩卖链接',
    userCode: '客户邮编',
    use: '用途',
    commodityLabelNumber: '商品标签编号',
    salesScreenshot: '售卖截图',
    exportPackingDetails: '导出装箱明细',
    actualWeight: '实际重量(kg)',
    remarksSingleRemarks: '备注单番备注',
    labelManagement: '标签管理',
    label: '标签',
    distributionService: '担当配属',
    allocationPurchase: '買付配属',
    distributionOfGoods: '梱包配属',
    customerLoginName: 'ユーザー名',
    expirationTimeOfMembership: '定額会員期限',
    putAway: '閉じる',
    orderList: '注文書',
    helpCustomersPickUpOrders: '顧客の代わりに注文書を提出',
    basicInformation: '基础信息',
    customerAccountInformation: '客户账号信息',
    passwordReset: 'パスワードリセット',
    SystemID: 'ID',
    lastAccessTime: '直近ログイン日',
    systemLoginName: 'ユーザー名',
    fullName: '名前',
    accountStatus: 'アカウント状態',
    membershipLevel: '会员等级',
    commissionRate: '手数料',
    introductionLecturer: '講師',

    quotaMember: '定額会員',
    expirationDateOfMembership: '定額会員期限',
    currentAccountBalance_yen: 'アカウント残高',
    accumulatedValueOfTheProduct_yen: '累計仕入商品代金',
    authorizeArrears_yen: '貸付可能額',
    authorizeOverdueTime: '授权欠费时间',
    authorizedArrearsDocument: '関係資料',
    newCustomerOfferExpires: '新規手数料無料',
    authorizationStatus: '授权状态',
    packingAuthorization: '装箱授权',
    latestOrderTime: '最新下单时间',
    latestDaigouOrderTime: '代理購入の最新注文時間',
    latestOemOrderTime: 'OEM最新注文時間',
    latestSmallOrderTime: '小口最新注文時間',
    customerLabel: '客户标签',
    invoiceRelatedInformation: '发票相关信息',
    invoiceRatio: '发票比例',
    customerSalesPlatform: '客户售卖平台',
    amazonStoreInformation: '亚马逊店铺信息',
    yahooStoreInformation: '雅虎店铺信息',
    lotteStoreInformation: '乐天店铺信息',
    other: '其他',
    openMembership: '开通会员',
    invoiceScaleSetting: '发票比例设置',
    quotaMembershipOpening: '定額会員申請',
    chatToolSettings: '聊天工具设置',
    setTheAmountOfAuthorizedArrears: '授权欠费额度设置',
    authorizedLimit: '授权额度',
    userStatus: '客户状态',
    customerSalesPlatformSetting: '客户售卖平台设置',
    screenshotOfSellingStoreInformation: '售卖店铺信息截图',
    detailed: '詳細',//詳細
    directAdditionalGoods: '直接追加商品',//直接追加商品
    shoppingCartAdd: '购物车追加',//购物车追加
    inventoryAddition: '商品库追加',//商品库追加
    amountOfGoods: '商品金額',//商品金額
    submitOrder: '提出订单',//提出订单
    orderGoodsDirectlyAdded: '订单商品直接添加',//订单商品直接添加
    submit: '提交',//提交
    increaseOrDecrease: '增减',//增减
    pleaseEnterTheMerchandiseLinkForRakumratPlatform: '请输入rakumrat平台的商品链接',//请输入rakumrat平台的商品链接
    pleaseAddAtLeastOneItem: '请至少添加一个商品',//请至少添加一个商品
    newTotal: '合計',//合計
    amountTotal: '合计金额',//合计金额
    internationalShippingSentakuSociety: '国際運送会社選択',//国際運送会社選択
    attachmentUploading: '附件上传',//附件上传
    clickUpload: '点击上传',//点击上传
    userSubmitOrderRemark: '注文書備考欄',//注文書備考欄
    userSubmitOrderRemarkTips: '* 对该订单有特殊要求的，可以在这边备注\n' +
      '* 备注后会同步显示给业务员',//* 对该订单有特殊要求的，可以在这边备注* 备注后会同步显示给业务员
    sentaku: "選択",//選択
    photo: "写真",//写真
    lowerSingular: "下单数",//下单数
    unitPriceYuan: '单价.元',//单价.元
    subtotalYuan: '小计(元)',//小计(元)
    labelSetting: '标签设置',//标签设置
    remarksField: '備考欄',//備考欄
    optionDetails: 'オプション詳細',//オプション詳細
    commodityWarehouse: '商品库',
    favorites: '收藏夹',
    failure: '失效',
    managementDesignation: '管理番号',
    commodityTitle: '商品名',
    addToOrder: '追加到订单',
    selected: '已选',
    shoppingCart: '购物车',
    change: '更改',
    operationAndMaintenance: '运维',
    makeAPublicAnnouncement: '发布公告',
    accountOfBackgroundAdministrator: '后台管理人员账号',
    noticeAnnouncementPreview: '通知公告预览',
    theProportionAllocatedToItselfWhenThereAreLowerLevels: '有下层级时 分配到自身的比例',
    afterSaleOfSpecificGoods: '具体商品售后',
    afterTheWholeOrder: '整个单子售后',
    deliveryRate: '配送单汇率',
    problemLogisticsNumber: '问题物流号',
    afterSaleReasonSelection: '售后原因选择',
    customerFeedbackProblem: '客户反馈问题',
    whetherTheCustomerInterfaceDisplays: '客户界面是否显示',
    problemScreenshotAdd: '问题截图添加',
    adviceOnAfterSaleHandlingOfBusiness: '业务售后处理意见',
    afterSaleExpenseAdjustmentDetails: '售后费用调整明细',
    nominalCostAdjustment: '费用调整名义',
    remarks: '備考欄',
    amountOfIndemnityYen: '赔款金额（円）',
    amountCharged: '收费金额（円）',
    aggregateAdjustment: '合计调整',
    screenshotOfAfterSalesProcessConfirmatio: '售后处理确认过程截图',
    putForwardInBulk: '批量提出',
    contactCustomer: '联系客户',
    customerFeedbackProblemRequestJP: '客户反馈问题诉求（日语）',
    adviceOnAfterSaleHandlingOfBusinessJP: '业务售后处理意见（日语）',
    amountOfIndemnity: '赔款数量',
    indemnitiesForGoods: '商品代赔款',
    returnOfDomesticFreight: '国内运费返还',
    commissionIndemnity: '手续费赔款',
    optionForCompensation: 'option赔款',
    orderRate: '订单汇率',
    purchaseNumber: '购买数',
    numberOfTransmissions: '发送数',
    refundModeEditing: '退款模式编辑',
    compensationForAdditionalServices: '附加服务赔款',
    paidFor: '已收费用',
    theEstimatedAmountOfCompensation: '预计赔款金额',
    goodsAfterSale: '商品售后提出',
    toBeProcessed: '待处理',
    customerToBeRepliedTo: '待回复客户',
    claimNumber: '赔款单号',
    afterSalesOrderNumber: '售后单号',
    indemnityStatus: '赔款状态',
    afterSaleCategory: '售后类别',
    chargeAdjustmentNominalSettingsThroughoutTheList: '整个单子费用调整名义设置',
    wholeListOfAftermarketReasonsSet: '整个单子售后原因设置',
    wafterSalesTime: '售后时间',
    totalIndemnity: '合计赔款.円',
    associatedReparations: '关联赔款',
    nominalSetting: '編集',
    causeSetting: '售后原因设置',
    afterSaleStatus: '售后状态',
    indemnityBearingRatio: '赔款承担比例',
    estimatedLiability: '预计承担金额',
    detailsOfAfterSalesOrder: '售后单详情',
    causeOfTheProblem: '产生问题原因（内部）',
    addAnInternalClaimSlip: '添加内部赔款单',
    liabilityForLoss: '赔款承担',
    claimIndemnity: '提出赔款',
    billOfIndemnity: '赔款单',
    categoryOfResponsiblePerson: '责任人类别',
    theOrganizationOfThePersonResponsible: '责任人所在组织',
    companyEmployee: '公司员工',
    externalLogisticsCompany: '外部物流公司',
    thirdPartySeller: '第三方卖家',
    detailsOfExpensesBorne: '承担费用明细',
    responsiblePersonSelection: '责任人选择',
    responsiblePersonRole: '责任人角色',
    bearingRatio: '承担比例',
    liablePerson: '责任承担人',
    myself: '本人',
    companyResponsibility: '公司承担',
    corporation: '公司',
    associatedResponsiblePerson: '关联责任人',
    billOfIndemnityAdded: '添加赔款单',
    confirmationOfClaims: '赔款确认',
    maximumIndemnity: '赔款上限',
    contrabandSurveillance: '违禁品监控',
    toBeConfirmedByYiwu: '待义乌确认',
    subjectToJapanConfirmation: '日本確認待ち',
    processingClass: '处理类别',
    monitoringReason: '监控原因',
    addMonitoredGoods: '添加监控商品',
    commodityMasterChart: '商品主图',
    manuallyAddPictures: '人工添加图片',
    operatingTime: '操作时间',
    monitorProductSettings: '监控商品设置',
    isCustomsIntercepted: '税関に差し止められたことがあるか',
    enableAutomaticAcquisition: '开启自动获取',
    commoditySource: '商品来源',
    imageAddition: '图片添加',
    customerSearchKeywordMaintenance: '客户搜索关键词维护',
    fillKeywordValue: '填充关键词值',
    artificialCorrectionOfKeywords: '人工修正的关键词',
    googleAutomaticallyTranslatesValues: '谷歌自动翻译值',
    commoditySpecificationMaintenance: '商品规格维护',
    systemEntryTim: '系统录入时间',
    chineseAttribute: '中文属性',
    manualCorrectionTranslation: '人工修正翻译',
    whetherTheServiceProcessIsSatisfactory: '服务流程是否满意',
    whetherToConfirmTheCurrentRating: '是否确认当前评价',
    homogeneousGrouping: '同分类分组',
    logisticsNumberSelection: '物流号选择',
    printed: '已打印',
    notPrinted: '未印刷',
    statusOfAllInspectedProducts: '全部检品状态',
    batchAddRemarks: '批量添加备注',
    lecturerSWithdrawal: '讲师提现',
    lecturerName: '讲师名字',
    LecturerID: '讲师ID',
    subordinateDepartment: '担当者',
    shelfSetting: '货架设置',
    orderbianhao: '订单编号',
    select: '选中',
    fullNamePM: '全部品名',
    nonStandardName: '非标准品名',
    allCustomers: '全部客户',
    numberOfProblems: '问题数',
    pleaseEnterTheShippingNumber: '配送依頼書Noをご記入ください',
    pleaseEnterID: '请输入ID',
    pleaseEnterTheOrderNumber: '请输入订单号',
    labelImportQuantity: '标签导入数量',
    deliveryTimeOfPresentation: '配送提出时间',
    customerDeliveryNote: '客户配送单商品备注',
    transactionLogisticsNumber: '交易/物流号',
    numOfLabels: '贴标标签数',
    shippingTime: '出货时间',
    confirmAndPropose: '确认提出',
    picture: '图片',
    remitter: '入金名義',
    remittanceAmoun: '入金額(円)',
    remittanceCustomer: 'お客様名',
    numberOfRemovableLibraries: '可移库数',
    startCharging: '开始计费',
    daysBilled: '已计费天数',
    CStime: '初始时间',
    specification: '规格',
    rotograph: '轮播图',
    defaultRecommendation: '默认推荐',
    dateOfRevision: '修改日期',
    searchResult: '搜索结果',
    timeOfClaim: '认领时间',
    pleaseEnterTheTrackingNumber: '请输入快递单号',
    signerSelection: '签收员选择',
    overallEvaluationOfDeliveryOrder: '配送单整体评价',
    viewDetails: '查看明细',
    customerEvaluation: '客户评价',
    problemDescriptionMS: '问题描述',
    deleteChangeMode: '删除改方式',
    nameOfLogisticsMode: '物流方式名称',
    modifiedSortNumber: '修改后排序编号',
    customerSingleFlipRemarks: '客户单翻备注',
    theCustomerSelectsThePropertyOfTheItem: '客户选择商品属性',
    sortNumbering: '排序编号',
    commodityMonitoring: '商品监控',
    fillInTheGoogleKeywordValue: '填充谷歌关键词值',
    fillInTheCustomerInputKeywordValues: '填充客户输入关键词值',
    maintenanceTime: '维护时间',
    maintenanceName: '维护人',
    searchDate: '搜索日期',
    formOrder: '下单模板',
    placeANewOrder: '提出新订单',
    packingQuantit: '装箱数量',
    addSalesScreenshots: '售卖截图添加',
    confirmUpload: '确认上传',
    comprehensiveLabel: '综合标签',
    ruleTag: '规则标签',
    serviceLabel: '业务标签',
    labelStatus: '标签状态',
    retrievalTimes: '检索次数',
    numberOfCustomers: '客户数',
    createACommunity: '创建群体',
    tagName: '标签名',
    commodityCommissionRatioConfiguration: '商品手续费比例配置',
    effectiveRule: '生效规则',
    currentActiveCommissionRate: '当前生效手续费比例',
    commissionRateAdjustment: '手续费比例调整',
    effectiveCommissionRate: '生效手续费比例',
    labelDistributionSingleListInterface: '贴标配送单列表界面',
    fBAOperationStatus: 'FBA操作状况',
    assignFBAOperations: '分配FBA操作',
    toBeAllocated: '待分配',
    toBeLabeled: '待贴标',
    labelin: '贴标中',
    pendingDeposit: '待入金',
    deliveryReceiptAfterReceiptOfCash: '入金后配送单',
    serialNumber: '序号',
    timeFKPayment: '付款时间',
    fullPurchase: '全部采购',
    linkedList: '链接列表',
    startTime: '开始时间',
    endTime: '结束时间',
    orderPersonnelAdjustment: '订单人员调整',
    roundDisplay: '整番显示',
    roundHide: '整番隐藏',
    expandTheDisplay: '各番展开显示',
    commodityNoteEditing: '商品备注编辑',
    BearCommodityNoteEditing: '担当、商品备注',
    purchaseCommodityNoteEditing: '采购、商品备注',
    DistributionBearCommodityNoteEditing: '配货、商品备注',
    containerTransferQuantity: '移箱数量',
    fBATranslationTime: 'FBA翻译时间',
    labelingTime: '贴标时长（h）',
    numberOfCopiesPrinted: '已打印数',
    numberOfServiceLabelsModifiedRemarks: '业务贴标数修改备注',
    specificTimePoint: '具体时间点',
    markingTime: '给标时间',
    timeToStartLabeling: '开始贴标时间',
    finishLabelingTime: '完成贴标时间',
    viewRemarks: '查看备注',
    fBAOperationRemarks: 'FBA操作备注',
    confirmToFillInTheOrderNumber: '确认填写单号',
    fBAOperationSelect: 'FBA操作选择',
    fBAOperationWorkloadStatus: 'FBA操作工作量状况',
    unpastedDeliverySingular: '未贴完配送单数',
    numberOfUnpastedLabels: '未贴完标数',
    attributesOfGoodsPlacedByCustomers: '客户下单商品属性',
    isBackToWaitTranslate: '是否回退到待翻译？',
    returnService: '退给业务',
    requotationRecordOfDeliveryOrder: '配送单重新报价记录',
    backoffReasonSetting: '回退原因设置',
    backoffChargeNominalSetting: '回退收费名义设置',
    backOffTheTimeOfReOffer: '回退重新报价时间',
    deliveryOrderNumber: '配送单单号',
    personOfReturn: '回退人',
    organizationOfAffiliation: '所在组织',
    deliveryOrderOperator: '配送单操作员',
    reasonForBackOff: '回退原因',
    whetherTheInternationalFreightIsRefunded: '国际运费是否回退',
    photoNotes: '图片备注',
    theReasonForTheBackoffIsExplained: '回退原因说明',
    detailsOfChangesInExpenses: '费用变动明细',
    newCategoriesAdded: '新增类别',
    returnTheAdditionalCharge: '回退追加收费名义',
    deliveryOrderRollbackRequotationRecord: '配送单回退重新报价记录',
    detailsAboutTheRollback: '具体回退说明',
    screenshotAddition: '截图添加',
    returnToCustomer: '退给客户',
    noReturnToCustomer: '不退给客户',
    whetherToReturnToTheCustomer: '是否退给客户',
    additionalCharge: '追加收费',
    returnToRegularWarehouse: '退回常规仓库',
    warehouseAddressMaintenance: '仓库地址维护',
    warehouseCode: '仓库编码',
    statusOfEnable: '启用状态',
    warehouseAddress_English: '仓库地址（英文）',
    warehouseAddress_Japanese: '仓库地址（日文）',
    nameOfWarehouse: '仓库名',
    newBuild: '新建',
    add_Warehouse: '添加-仓库',
    edit_Warehouse: '编辑-仓库',
    typeOfWarehouse: '仓库类别',
    whetherEnabled: '是否启用',
    APPVersionControl: 'APP版本控制',
    Android: '安卓',
    IOS: '苹果',
    officialPackageName: '正式包名',
    timeOfRelease: '发布时间',
    popUpCopy_Japanese: '弹窗文案（日文）',
    popUpCopy_Chinese: '弹窗文案（中文）',
    whetherItIsStronger: '是否强更',
    versionNumber: '版本号',
    checkEmail: 'Email確認',
    additionalServicesJapanese: '附加服务日文',
    combinationOfOrders: '订单合单',
    orderUnpacking: '订单拆单',
    orderPrefixSetting: '下单前缀设置',
    orderPhoneSettings: '下单手机设置',
    recipientSMobileNumber: '携帯番号',
    firmOffer: '确认谈价',
    confirmFreight: '确认运费',
    excelOrder: 'Excel下单',
    deliveryOrderDeletion: '配送单删除',
    remittanceAmount_yen: ' 入金額(円)',
    printList: ' 打印清单',
    qrCodeUpload: '二维码上传',
    sameTransactionNumbe: '同交易号',
    duplicateLogisticsNumbe: '复制物流号',
    arrivalTime: '到货时间',
    names: 'お客様名',
    //新增
    porderList: '配送依頼書',
    plainTextLabel: '纯文字标',
    textLabel: '文本标',
    rateAtTimeOfPayment: '付款时汇率',
    batchRollback: '一括取消',
    fullRemittance: 'すべて',
    toBeRemitted: '振込待ち',
    remittanceHasBeenMade: '振込完了',
    bulkFilling: '批量填充',
    adjustTheSpreader: '调整布标员',
    // 11111
    numberOfBidDemolitions: '实缝标数',
    numberOfActualSplitBids: '实拆标数',
    liberalSVIP: 'SVIP申請',
    OfflSVIP: 'SVIP終了',
    orderDownload: '订单下载',
    purchaseBargaining: '采购谈价',
    negotiatedUnitPrice: '谈价单价',
    negotiatedFreight: '谈价运费',
    actualNumberOfTags: '实际标签数',
    expectedNumberOfTags: '预计标签数',
    editPic: '修改头像',
    editPassword: '修改密码',
    dueIndemnity: '理应赔款',
    shippingMarkForDistribution: '配货打印唛头',
    jianpinCenter: '检品中',
    manualOrderingOnTaobao: '淘宝人工下单',
    userRamrk: '運営備考欄',
    userBeikao: 'お客様備考欄',
    numberOfArrivals: '到货番数',
    subaccountID: '社員アカウントID',
    ChuliTime: '处理时间',
    reasonForCompensation: '赔款原因',
    totalIndemnityYuan: '合计赔款.元',
    newOrderCompensation: '新建订单赔款',
    actualCompensation: '承担比例',
    actualCommitmentAmount: '实际承担金额',
    boundInstructor: '講師結び',
    batchDeleteLabels: '批量删除标签',
    actualPayment: '实际需支付',
    read: '已读',
    unread: '未读',
    printPackingListNoPrice: '打印装箱单',
    businessProcessing: '业务处理',
    jurisdiction: '权限',
    japaneseOffice: '日本事务所',
    customerBaseInformation: '客户基础信息',
    customerProfilePicture: '客户头像',
    chat: '聊天',
    latestChatTime: '最新聊天时间',
    deliveryOrderInProgress: '进行中配送单',
    feedback: '意见反馈',
    fillInReason: '填写原因',
    newEmergency: '新增紧急件',
    inspectionDetail: '检品详细',
    financialAuditRemarks: '财务审核备注',
    updatePurchaseRemark: '修改购买备注',
    mailSending: '邮件发送',
    mailTitle: '邮件标题',
    mailContent: '邮件内容',
    theEmailSubjectCannotBeBlank: '邮件标题不能为空',
    theEmailContentCannotBeEmpty: '邮件内容不能为空',
    mailList: '邮件列表',
    topicKeyword: '主题关键词',
    notViewed: '未查看',
    viewed: '已查看',
    sender: '发送人',
    sendingTime: '送信時間',
    mailDetails: '邮件详情',
    // 9.25新增
    bankName: '银行名',
    transferNoteNei: '備考欄(内部)',
    mingYi: 'お客様ページ表示',
    scanningTime: '扫描时间',
    scanBarCode: '扫描条码',
    labelComparison: '标签比对',
    tagCoding: '标签编码',
    labelCheck: '核对',
    chineseDomesticLogistics: '中国国内物流',
    noLogisticsInformation: '物流情報はありません',
    salesmanIndex: '业务员首页',
    purchaseIndex: '采购员首页',
    distributionIndex: '配货员首页',
    testArticleIndex: '检品员首页',
    deliverableOrder: '可发货订单',
    manualSetupFreeOfCharge: '人工设置免手续费',
    liberal: '开通',
    startingFeeFreeDate: '人工设置开始日期',
    endOfFeeFreeDate: '人工设置结束日期',
    overdue: '紧急',
    isOverdue: '是否紧急',
    numberOfLabelEntries: '贴标填写数',
    causeOfInconsistency: '不一致的原因',
    businessCommodityNotes: '业务的商品备注',
    depositInformation: '入金信息汇总',
    flowDetailFuzzyMatching: '入金名義リスト',
    exactMatchingOfAmounts: '金额精确匹配',
    matchingState: '状態',
    paymentDetailsContents: '出入金明细（内容）',
    systemSerialNumber: 'RシステムNO',
    otherRemarks: '備考欄',
    currentBalance: '銀行残高',
    depositAmount: '入金金额(円)',
    withdrawalAmount: '出金金额(円)',
    journalDetail: '銀行名義',
    flowNumber: '番号',
    bankStatementDate: '銀行着金時刻',
    importDate: 'アップロード時間',
    automaticFinancialRecognition: '自动财务确认',
    uploadStream: 'アップロード',
    selectFile: '选择文件',
    depositName: '入金名义（给客户的)',
    purchaseAllocation: '采购分配',
    distributionAllocation: '配货分配',
    generateLink: '生成链接',
    kunbaozhong: '梱包中',
    depositNominalMaintenance: '入金名義リスト',
    bank: '银行',
    currentDefaultName: 'デフォルト',
    setAsDefault: 'デフォルトへ設定',
    currentDefault: '当前默认',
    itWentOnTheShelves90DaysAgo: '90天前上架完',
    purchaseDocumentaryRemarks: '采购跟单备注',
    orderPendingDeposit: '订单待入金',
    orderDepositToBeConfirmed: '订单入金待确认',
    porderWaitPaySubmit: '配送单待入金',
    porderPayWaitConfirm: '配送单入金待确认',
    blockMail: '屏蔽邮件',
    pendingBusinessConfirmation: '担当確認待ち',
    toBeReviewed: '内部審査待ち',
    waitingForPayment: '振り込み待ち',
    customerConfirmation: '完了',
    serviceConfirmation: '业务确认',
    examine: '审核',
    finalPurchaseCost: '最终采购成本',
    communicationScreensho: '沟通截图',
    auditRemarks: '審査備考',
    copyTheWithdrawalLink: '返金urlをコピーする',
    estimatedTimeOfArrival: '着金予定',
    abandon: '废弃',
    abandonmentApplication: '废弃申请',
    reasonForAbandonment: '废弃原因',
    requestForCancellationOfDeliveryOrder: '配送单废弃申请',
    confirmationPersonnelRemark: '确认人员备注',
    proposedObsolescenceTime: '提出废弃时间',
    topUp: '充值',
    paymentInformation: '返金情報',
    paymentVoucher: '打款凭证',
    flowMatching: 'システム照合',
    userEmail: '客户邮件',
    emailSubject: '邮件主题',
    Nodata: '暂无数据',
    userChat: '客户聊天',
    ordinaryCustomer: '普通客户',
    potentialCustomer: '潜力客户',
    whetherToRenewQuotaMembership: '是否续费定额会员',
    Settings: '设置',
    renewalQuotaMember: '续费定额会员',
    lastUpdateTime: '最新更新时间',
    inspectionTransactionSearch: '取引番号（検品操作）',
    inspectionLogisticsSearch: '物流番号（検品操作）',
    commissionCommitment: '手数料負担',
    rakuUndertake: 'RAKUMART負担',
    userUndertake: 'お客様負担',
    financialOperationTim: '财务操作时间',
    depositName: '入金名义',
    alreadyMatched: '已匹配',
    unmatch: '未匹配',
    sameOrderSearch: '同订单搜索',
    switchView: '切换视图',
    submissionTime90Days: '提出时间90天',
    depositNominalFuzzySearch: '入金名義検索',
    generateNetEaseOrders: '生成网易订单',
    discardType: '废弃类型',
    customerRequestAbandonment: '客户要求废弃',
    unableToContactTimeoutDiscard: '联系不上超时废弃',
    pipelining: '流水绑定',
    confirmThatYouWantToStreamBind: '确认要流水绑定？',
    reminderTimes: '提现次数',
    Kintype: '銀行',
    returnToTemporaryStorage: '退回临时保存',
    isReturnToTemporaryStorag: '是否退回临时保存？',
    expectedNumberOfLabels: '预计贴标数',
    clientBillList: '客户账单',
    dataSourceName: '数据源名称',
    timeSelection: '时间选择',
    lastAppointment: '上一次预约',
    dataSource: '数据源',
    downloadByAppointment: '预约下载',
    subscriptionCompletionTime: '订阅完成时间',
    timeToSubmitDeposit: '提交入金时间',
    confirmDepositTime: '确认入金时间 ',
    thereIsNoFlowMatchin: '見つかりませんでした ',
    purchaseProposalTime: '采购提出时间 ',
    inAbout5Days: '近5天上架完',
    partialRemittance: '分批汇款',
    paymentAmountSetting: '支付金额设定',
    payOnFirstPayment: '付首款时付',
    payWithTheBalance: '与尾款一起支付',
    finalPaymentNode: '尾款支付节点',
    preWarehouse: '上架仓库前',
    beforeDeliveryOrder: '提配送单前',
    theFirst: '首款',
    balancePayment: '尾款',
    orderPaymentMethod: '订单支付方式',
    HScode: 'HS编码',
    markedWoodenCase: '标记木箱',
    unmarkedCase: '取消标记木箱',
    bindingPurchase: '绑定采购',
    bindingAllocation: '绑定配货',
    markManuallyReviewed: '手動操作済み',
    estimatedMonthlyOrderAmount: '月预估下单额',
    batchConfirmationInJapan: '日本批量确认',
    qaManage: '前台QA配置',
    addACategory: '添加一类类目',
    addQuestion: '添加题目',
    categoryName: '类目名',
    subject: '题目',
    answer: '答案',
    addCategory: '添加类目',
    editCategory: '编辑类目',
    editQuestion: '修改题目',
    batchAllocationOfInspectionProportion: '检品比例批量分配',
    websiteConsultation: '网站咨询',
    numberOfDeliveryOrdersProposed: '已提出配送单数',
    refundAmountVoucher: '退款金额凭证',
    uploadSpecialCustomerTags: '特殊客户标签上传',
    pendingProcurementReview: '待采购审核',
    reviewed: '已审核',
    pleaseSelectTheType: '请选择类型',
    defaultImporter: '默认进口商',
    defaultShippingAddress: '默认收货地址',
    blacklistedStoreOrderNumber: '黑名单店铺订单号',
    setRemarks: '设置备注',
    documentaryRemarks: '跟单备注',
    history: '历史',
    documentaryRemarksSettings: '跟单备注设置',
    promptPersonnel: '提示人员',
    historyRemark: '历史记录',
    viewSituation: '查看情况',
    reminderForTrackingNotes: '跟单备注提示',
    timedMembershipActivation: '定时开通会员',
    customerMarking: '客户标记',
    modifyName: '修改名称',
    batchDeletion: '批量删除',
    batchAdjustmentOfOrders: '订单批量调整',
    batchAdjustmentOfDeliveryOrders: '配送单批量调整',
    confirmScreenshot: '确认截图',
    documentaryRecords: '跟单记录',
    addPeople: '添加人',
    remarkTime: '备注时间',
    remarkContent: '备注内容',
    userLink: '客户页面链接',
    websiteUpdateLogs: '网站更新日志',
    updateContent: '更新内容',
    port: '端口',
    releaseDate: '发版日期',
    chatSummary: '聊天信息汇总',
    chatInfo: '聊天信息',
    suspectedComplaint: 'クレームの疑い',
    confirmComplaint: 'クレーム確定',
    complaintConfiguration: 'クレーム検知設定',
    complaintVocabulary: 'クレーム用語',
    recentOrderPlacementTime: '最近下单时间',
    accumulatedShipmentAmount: '累计出货金额',
    sendTo: '送信対象',
    chatContent: 'チャット内容',
    confirmStatus: '确认状态',
    suspectedComplaint: 'クレームの疑い',
    confirmComplaint: 'クレーム確定',
    nonComplaint: '非クレーム',
    whetherToCancelTheComplaint: 'whetherToCancelTheComplaint',
    upAndDown: '最大50件',
    photographyServices: '摄影服务',
    photographOrder: '摄影订单',
    correspondingPersonnel: '对应人员',
    createANewTaskOrder: '新建任务单',
    uploadFiles: '上传文件',
    expectedCompletionTime: '预计完成时间',
    numberOfShotsTaken: '拍摄数量',
    taskToBeFilmed: '待拍摄任务',
    actualCompletionTime: '实际完成时间',
    actualNumberOfShotsTaken: '实际拍摄数量',
    photographFile: '摄影文件',
    photographyNotes: '摄影备注',
    toBePhotograph: '待拍摄',
    shootingCompleted: '拍摄完成',
    sendingEmails: '发送邮件',
    classification1688: '1688分类',
    consultationRegistration: '咨询登记',
    qaQuery: 'QA查询',
    qaSummary: 'QA汇总',
    classification: '分类',
    consultationTime: '咨询时间',
    consultationSource: '咨询来源',
    customerConsultationContent: '客户咨询内容',
    replyContent: '回复内容',
    consultationRecords: '咨询记录',
    recordGenerationTime: '记录生成时间',
    lecturerRegistrationExpirationDate: '讲师注册到期时间',
    listMaintenance: '榜单维护',
    listNameChinese: '榜单名称（中文）',
    listNameJapanese: '榜单名称（日文）',
    Pallet1688ID: '1688货盘ID',
    enablingStatus: '启用状态',
    notesFromJapaneseAccountingFirms: '日本事务所备注',
    AIAutomaticAcquisition: 'AI自动获取',
    logisticsName: '物流名称',
    JapaneseRankingExplanation: '日文榜单说明',
    boxKin: '箱子商品总金额',
    getTemporaryPassword: '获取临时密码',
    calculateBusinessPerformance: '算业务绩效',
    calculateDistributionPerformance: '算配货绩效',
    calculateProcurementPerformance: '算采购绩效',
    defaultICON: '默认ICON',
    selectionICON: '选中后ICON',
    optionPic: 'option图片',
    optionVideo: 'option视频',
    reparationType: '赔款类型',
    batchSelectProducts: '商品一括選択',
    joinProductLibrary: '加入商品库',
    joinProductManagement: '商品管理に追加',
    joinProductManagementSuccess: '商品管理に追加しました',
    joinProductManagementFailed: '商品管理への追加に失敗しました',
    businessConfirmationTime: '业务确认时间',
    ministerReviewTime: '部长审核时间',
    cancelMembershipActivation: '取消开通会员',
    compensationDetails: '赔款明细',
    responsiblePerson: '责任人',
    actualCompensationAmount: '实际赔款金额',
    correspondingOrganization: '对应组织',
    waitingForProcurement: '等待采购',
    waitingForFinancialPayment: '等待财务付款',
    Unpacking: '拆包',
    inspection: '普检',
    Simplify: '精检',
    SeamMarking: '缝标',
    personnel: '人员',
    abandonedList: '打印废弃单',
    pendingInternalProcessing: '内部処理待ち',
    ToBeReviewedByTheMinister: '部長処理待ち',
    Processed: '処理済',
    thirdPartyWarehouseAddress: '第三者倉庫住所',
    handlingIdeas: '処理の流れ',
    confirmedComplaint: 'クレーム確定済み',
    CustomerComplainHandling: 'クレーム処理',
    ProcessScreenshots: '処理のスクリーンショット',
    MinistersMessage: '部長コメント',
    ImmediateReview: '即時処理',
    mate: 'マッチ',
    handle: '処理',
    JapaneseMessage: '日本事務所コメント',
    SeveritProblem: '問題の深刻度',
    ProblemSolvingDuration: '問題発見-解決の所要時間',
    CustomeImportance: '顧客の重要度',
    BusinessSituation: '担当の処理解決状況',
    score: '評価',
    SeveritProblemText: '深刻度は1星から5星まで、星が多いほど深刻',
    CustomeImportanceText: '重要度は1星から5星まで、星が多いほど顧客が重要',
    BusinessSituationText: '担当者の処理解決は1星から5星まで、星が多いほど完璧に解決',
    ProblemSolvingDurationText: '所要時間の評価は1星から5星まで、星が多いほど時間が短く、早く解決したことを示す',
    strip: '件',
    GoBack: '前のページに戻る',
    fourSteps: 'マッチ/処理/評価/確認',
    FuzzySearchHistoricalRecords: '履歴の検索',
    ministersScreenshot: '部长截图',
    complaintType: '投诉类型',
    raiseAnotherOrder: '再提一单',
    afterSalesReasons: '售后原因',
    isThereACompensationClaim: '是否有赔款单',
    reasonForApplication: '申请原因',
    mergePayments: 'まとめ入金',
    couponSummaryList: '券汇总列表',
    openingTime: '开通时间',
    promotionStartTime: '优惠开始时间',
    endTimeOfDiscount: '优惠结束时间',
    applicationTimeInformation: '申请时间信息',
    couponInformation: '券信息',
    limitnumberOfAvailableTimesdiscountRatio: '额度/可用次数/折扣比例',
    usageInformation: '使用信息',
    canEnterTheSystem: '可进入系统',
    selectRole: '选择角色',
    depositNumber: '入金番号',
    commodityManagementCode: '商品管理コード',
    encodingFormat: 'コード形式',
    productType: '商品タイプ',
    tagInformation: 'ラベル情報',
    productFile: '商品ファイル',
    materialConsumption: '消耗',
    materialManagement: '副資材管理',
    orderPlan: '発注プラン',
    createPlan: 'プラン作成',
    editPlan: 'プラン編集',
    confirmDeletePlan: 'このプランを削除しますか？',
    generateDefaultPlan: 'デフォルトプラン生成',
    defaultOrder: 'デフォルト発注',
    mainProductInfo: 'メイン商品情報',
    comboProductInfo: 'セット商品情報',
    comboProduct: 'セット商品',
    materialBinding: '副資材紐付け',
    pointPerSet: '点/セット',
    labelNumber: 'ラベル番号',
    labelText: 'ラベルテキスト',
    noOrderPlan: '発注プランがありません',
    planLatestUpdateTime: 'プラン最新更新時間',
    listView: 'リスト表示',
    cardView: 'カード表示',
    planName: 'プラン名',
    pleaseEnterPlanName: 'プラン名を入力してください...',
    defaultOrderUse: 'デフォルト発注で使用',
    orderLink: '発注リンク',
    addMatchingProduct: '同梱商品を追加',
    mainProduct: 'メイン商品',
    matchingProduct: '同梱商品',
    matchingProductName: '同梱商品名',
    useLatestOrderLink: '最新の発注リンクを使用',
    orderLinkSupportTip: '現在1688、淘宝、天猫など国内プラットフォームに対応しています。その他のプラットフォームは非対応です。非公開商品の場合は、発注後に手動対応となります',
    productAttributes: '商品属性',
    purchasePrice: '仕入価格',
    clickToSelect: 'クリックして選択',
    addNewTag: '新規ラベル追加',
    labelEditing: 'ラベル編集',
    labelType: 'ラベルタイプ',
    pleaseSelectLabelType: 'ラベルタイプを選択してください',
    pleaseEnterLabelNumber: 'ラベル番号（SKU）を入力してください',
    pleaseEnterCommodityCode: '商品コード（ASIN/商品URL）を入力してください',
    pleaseEnterLabelText: 'ラベルテキストを入力してください',
    selectMaintainedTag: '既存ラベルを選択',
    materialUsage: '副資材使用',
    noTag: 'ラベルがありません',
    noHistoryTag: '履歴ラベルがありません',
    noMaintainedTag: '維持済みラベルがありません',
    noBoundMaterial: '紐付け済み副資材がありません',
    queryMaterialStockGrids: '保管場所を確認',
    materialCurrentStock: '現在庫',
    noMaterialStockGrids: '保管場所の在庫はありません',
    materialMasterIdRequired: '有効な副資材マスターIDがありません',
    noMaterial: '副資材がありません',
    noAdditionalServices: '付加サービスがありません',
    inventoryQuantity: '在庫数量',
    saveSuccess: '保存に成功しました',
    customerRemarks: '顧客備考',
    addComboProduct: 'セット商品を追加',
    comboItem: '同梱物',
    comboChildLimitTip: 'セット商品は子商品を最大3つまで紐付けできます',
    historyTag: '履歴ラベル',
    bindingAuxiliaryMaterials: '副資材を紐付け',
    pleaseEnterMaterialName: '副資材名を入力してください',
    warehouseType: '倉庫タイプ',
    enableThisPlan: '使用する',
    pleaseSelectMainProductAttribute: 'メイン商品の属性を選択してください',
    // 与 zh.js 同步补充的日文翻译
    subjectToConfirmation: "運営確認待ち",
    theNumberOfAdditionalServicesIsAbnormal: "追加サービスの数が異常です",
    numberOfCloth: "布ラベルの枚数",
    batchAdjustPermissions: "権限の一括調整",
    packagingCompletionTime: "梱包完了時間",
    searchTime: "検索時間",
    partialCustomersSASS: "一部の顧客 - SASS",
    customerDataAnalysis: "顧客データ分析",
    overviewInformation: "一般情報",
    afterSalesManagement: "販売後の管理",
    deliveryNoteInformation: "配送依頼情報",
    relatedInformation: "関連情報",
    customerDynamics: "お客様のニュース",
    domesticDeliveryInProgress: "国内配送中",
    operationLog: "操作ログ",
    invoiceRecord: "請求書記録",
    depositAndWithdrawalRecords: "入出金記録",
    afterSalesInformation: "アフターサービス情報",
    dataDisplayBoard: "データ表示板",
    orderStatistics: "注文統計",
    orderQuantity: "注文数量",
    saveMoney: "節約額",
    domesticFreightRatio: "国内送料比率",
    additionalServiceFeeRatio: "追加サービス料率",
    totalKin: "合計金額",
    shipmentAmount: "出荷金額",
    numberOfDeliveryOrders: "配送依頼数",
    deliveryOrderStatistics: "配送依頼統計",
    shipmentAmountY: "出荷金額（元）",
    deliveryMethod: "配送方法",
    orderDeliveryTime: "注文納期",
    numberOfProblematicProductOrders: "問題商品数",
    customerDepositTime: "お客様の入金時間",
    expectedShelfLife: "入庫予定時刻",
    refundAmount: "返金額",
    wangwang: "AliWangWang",
    afterSalesQuantity: "アフターセールス数量",
    totalAfterSalesAmount: "アフターセールス総額",
    orderDeliveryNumber: "注文/配送番号",
    completionTime: "完了時間",
    afterSalesAmount: "アフターセールス金額",
    correspondingFollowUpPersonnel: "対応フォロー担当者",
    personnelConfiguration: "人事設定",
    personnelConfigurationSettings: "スタッフ配置の設定",
    proportion: "割合",
    followUpPersonnel: "フォローアップ担当者",
    actualNumberOfSets: "実際のセット数",
    actualNumberOfCapsules: "実際のフィルム包装数",
    waitingForTheMinisterSReplyToConfirm: "部長の確認回答待ち",
    ministerConfirms: "部長確認",
    japanConfirms: "日本が確認した",
    ministerialReview: "部長審査",
    ministerConfirmsReply: "部長の確認回答",
    beginnerSGuide: "初心者向けガイド",
    addDescription: "説明を追加",
    groupInformationPull: "グループ情報取得",
    massMessaging: "グループメッセージ",
    sendingStatus: "送信ステータス",
    timedTransmissionTime: "送信予定時刻",
    addDate: "日付を追加",
    exportSendingDetails: "送信詳細のエクスポート",
    isThereAProblemWithTheProduct: "何か問題のある商品はありませんか？",
    specialGroupAddition: "特別グループへ追加",
    createGroup: "グループの作成",
    newDeliveryOrderCompensation: "配送依頼の補償を新規作成",
    compensationAmount: "補償金額",
    amountOfShippedGoods: "出荷商品金額",
    quantityOfShippedGoods: "出荷された商品の数量",
    noProceduresRequiredForDistribution: "手続き不要で発行可能",
    generateCoupons: "クーポンの生成",
    distributeImmediately: "即時発行",
    batchThawing: "バッチ解凍",
    batchFreeze: "一括凍結",
    willTheSelectedCustomerSAccountBeUnfrozen: "選択した顧客のアカウントの凍結を解除するかどうか",
    willTheSelectedCustomerSAccountBeFrozen: "選択した顧客のアカウントを凍結するかどうか",
    applyTime: "申請時間",
    addServiceOrder: "新しいサービス注文を追加する",
    vacuumCompression: "真空圧縮",
    plasticSealing: "プラスチックシール",
    bubbleWrapFilm: "バブルラップ",
    supportingFacilities: "サポートする",
    serviceOrderNumber: "サービス注文番号",
    serviceOperator: "サービスオペレーター",
    serviceOrderAttachment: "サービス注文の添付ファイル",
    submitToInspection: "検査に出す",
    operationCompleted: "操作が完了しました",
    serviceProcessing: "サービス保留中",
    serviceProgress: "サービス中",
    serviceCompleted: "サービス完了",
    processingQuantity: "処理量",
    actualProcessing: "実際の処理",
    changeRequiredOperationQuantity: '必要作業数量を変更',
    enterRequiredOperationQuantity: '必要作業数量を入力してください',
    changeHandler: "ハンドラーの変更",
    batchDispatchInspector: '検品担当者一括割り当て',
    selectedInspectionOrderCount: '選択済み検品票：{count}',
    inspectionDispatchProgress: '検品票の割り当て進捗',
    inspectionDispatchSuccess: '検品票の割り当てが完了しました',
    inspectionDispatchFailed: '検品票の割り当てに失敗しました。リストを更新しました',
    batchDispatchServiceOperator: 'サービス担当者一括割り当て',
    selectedServiceOrderCount: '選択済みサービス注文：{count}',
    serviceDispatchProgress: '割り当て進捗',
    serviceDispatchSuccess: 'サービス注文の割り当てが完了しました',
    serviceDispatchFailedCount: '{count}件の割り当てに失敗しました。リストを更新しました',
    startOperation: "運転開始",
    reasonDeletion: "削除理由",
    sassClientList: "SASS顧客リスト",
    batchTransfer: "一括転送",
    batchTransferOrderSettings: "一括転送順序の設定",
    immediateTransition: "今すぐ転送",
    logisticsInformationInquiry: "物流情報照会",
    logisticsStatus: "物流状況",
    receiversNote: "受取担当者備考",
    pleaseEnterTheLogisticsTrackingNumber: "物流注文番号を入力してください",
    scanned: "スキャン済み",
    unscan: "待って描く",
    productClassificationFiltering: "製品カテゴリフィルター",
    productMarkingSettings: "商品タグの設定",
    productMarking: "商品マーク",
    tagNameSetting: "マーク名設定",
    businessFollowUpNotes: "ビジネスフォローアップメモ",
    customsClearanceFee: "通関手数料",
    compensationCategory: "報酬区分",
    exportWarehouseData: "ウェアハウスデータのエクスポート",
    theInvoiceIncludesOtherAmounts: "請求書には他の金額が含まれています",
    forwardToMembers: "フォワードメンバー",
    forwardingMonthlyFeeDueDate: "転送月額料金の支払期限",
    addProduct: "追加商品",
    manualOrdering: "手動発注",
    manualOrdering1688: "1688手動発注",
    orderNow: "今すぐ注文",
    confirmOrderPlacement: "注文を確認する",
    adjustTheOperator: "調整演算子",
    productsInProgress: "進行中のアイテム",
    historicalProductData: "過去の商品データ",
    informationMaintenance: "情報保守",
    toBindManagementNumber: "紐付ける管理番号",
    dataMaintenance: "データメンテナンス",
    noNeedToMaintainTheProduct: "メンテナンスは不要です",
    productV2NoNeedStatus: "メンテナンス不要",
    shopName: "店名",
    shopID: "ストアID",
    factory: "工場",
    batchRestore: "バッチ復元",
    selectProductsFromTheSameStore: "同じストアから商品を選択する",
    selectProductsWithTheSameLink: "同じリンクを持つ製品を選択してください",
    reduction: "復元する",
    batchBindingOfEXCEL: "EXCELバッチバインディング",
    batchSetManagementNumber: "管理番号を一括設定",
    relatedOrders: "関連する注文",
    excelOneClickImport: "EXCELワンクリックインポート",
    import: "インポート",
    importOneItemOfProductData: "商品データをまとめてインポート",
    productImportResult: '商品インポート結果',
    productImportTotal: '合計',
    productImportUpdated: '成功',
    productImportFailed: '失敗',
    productImportSkipped: 'スキップ',
    productImportAiFixed: 'AI修正',
    productImportDryRun: '今回は事前確認のため、データは更新されていません',
    productImportSuccessDetails: '成功明細',
    productImportFailedDetails: '失敗明細',
    productImportNoSuccess: '更新に成功したデータはありません',
    productImportNoFailed: '失敗データはありません',
    productImportRow: 'Excel行',
    productImportManagementNo: '管理番号',
    productImportSystemCode: 'システムコード',
    productImportColumn: '項目',
    productImportRaw: '元の値',
    productImportReason: '失敗理由',
    productImportExpected: '想定値',
    productImportExample: '例',
    productImportSelectFile: 'Excelファイルを選択してください',
    productImportFileType: 'XlsまたはXlsxファイルのみアップロードできます',
    productImportUploadFailed: 'ファイルのアップロードに失敗しました',
    listExpansion: "リストの展開",
    materialExpandAll: "一括展開",
    materialCollapseAll: "一括折りたたみ",
    selectProductType: "製品タイプを選択してください",
    productManagementRemarks: "製品管理備考",
    customerID_CustomerName: "お客様ID/お客様名",
    productLabelMultipleChoice: "商品タグ（複数選択）",
    doYouWantToSetOPTION: "OPTIONを設定するかどうか",
    isTheLabelBound: "タグをバインドするかどうか",
    whetherToBindAuxiliaryMaterials: "付属品をバインドするかどうか",
    productName_ProductID_ProductLink: "製品名/製品ID/製品リンク",
    factoryNameFactoryIDFactoryLink: "工場名/工場ID/工場リンク",
    mainImage: "メイン画像",
    customsClearanceInformation: "通関情報",
    productNameChinese: "製品名（中国語）",
    productNameJapanese: "製品名（日本語）",
    physicalImage: "物理的な画像",
    packingDiagram: "パッケージ図",
    productCustomizationFile: "製品カスタマイズファイル",
    inspectionInstructionBook: "検品指示書",
    photographyGuidebook: "写真撮影の指示",
    listCollapse: "リストの折りたたみ",
    productList: "製品一覧",
    singleWeightOfProduct: "製品単体重量",
    automaticallyFollowOrders: "注文は自動的に実行されます",
    basicSettings: "基本設定",
    controlOverInvoices: "請求書管理",
    productFileManagement: "製品ファイルの管理",
    accessorySettings: "賦形剤の設定",
    optionSettings: "オプション設定",
    productLabelManagement: "商品タグの管理",
    categoryOfProhibitedItems: "密輸品のカテゴリー",
    support: "サポート",
    noSupport: "サポートされていません",
    uploadPhysicalImage: "物理的な写真をアップロードする",
    synchronization: "同期する",
    picturePublic: "画像公開",
    usedWhenPlacingAnOrder: "ご注文時にご利用ください",
    fileUpload: "ファイルのアップロード",
    video: "ビデオ",
    chargingStandards: "請求基準",
    specialRequirements: "特別なリクエスト",
    file: "ファイル",
    uploadVideo: "ビデオをアップロードする",
    selectSystemOptions: "システムオプションを選択してください",
    createCustomOptions: "カスタムオプションを作成する",
    purchaseInformationMaintenance: "購入情報のメンテナンス",
    purchasingChannels: "購入チャネル",
    createFileClassification: "ファイルカテゴリの作成",
    onLine: "オンライン",
    offline: "オフライン",
    businessContact: "業務連絡",
    purchasingContactPerson: "調達窓口",
    factoryContact: "工場連絡先",
    pleaseEnterTheNameOfTheContactPerson: "連絡先名を入力してください",
    contactPhoneNumber: "連絡先電話番号",
    offlinePaymentMode: "オフライン支払いモード",
    contractDocuments: "契約書類",
    fullPayment: "全額支払う",
    partialPayment: "分割払い",
    code: "エンコーディング",
    selectEncoding: "エンコーディングの選択",
    english: "英語",
    hscodeCodeQuery: "HSCODEエンコードクエリ",
    lookup: "探す",
    tariffRate: "関税率",
    sizeWeight: "寸法・重量",
    latestUpdateTime: "最終更新時間",
    specialProducts: "スペシャルグッズ",
    orderRelated: "注文関連",
    purchaseStage: "購入段階",
    RAKUMARTWarehouse: "楽マート倉庫",
    badData: "悪いデータ",
    PendingDeliveryToRakumart: "配送待ち ラクマート",
    PendingShipment: "出荷を待っています",
    Purchasing: "購入する",
    DefectResolved: "処理が完了しました",
    DefectPendingDecision: "間違った決定が保留中",
    DefectInProgress: "不正な処理が進行中です",
    ShippableQuantity: "出荷可能な数量",
    InternationalTransport: "国際配送",
    ShipmentOrderPendingConfirmation: "配達注文は確認中です",
    PackingInWarehouse: "倉庫は梱包中です",
    PendingPayment: "支払い保留中",
    ArrivalProcessing: "職場に到着",
    ReceivedPendingOperations: "作業待ちの商品を受け取りました",
    timeForHomework: "宿題に到着",
    ArrivalOperations: "処理が完了しました",
    DeliverySigned: "受領済み",
    WaitingForCourier: "物流会社が荷物を集荷するのを待っています",
    InternationalShipping: "国際配送",
    lookOrder: "注文を見る",
    lookWarehouse: "倉庫を見る",
    lookPorder: "配達注文を表示する",
    dataDisplay: "データ表示",
    seeMore: "もっと見る",
    purchaseData: "購入データ",
    ShipmentData: "配送データ",
    CommonShippingLogistics: "一般的に使用される配送物流",
    shipmentRecord: "出荷記録",
    purchaseFrequency: "購入数",
    TotalPurchaseVolume: "購入総額",
    TotalPurchaseAmount: "購入総額",
    ExpensesIncurredOutsideProduct: "商品以外にかかった費用",
    AveragePurchasePrice: "平均購入価格",
    MinimumPurchasePrice: "最低購入価格",
    maxPurchasePrice: "最大購入価格",
    NumberShipments: "出荷数",
    ShipmentQuantity: "出荷数量",
    DeliveryTime: "発送日",
    ProcessingDeliveryTime: "処理期限",
    DeliverTimCommodityProcurement: "商品の購入と納品日",
    AverageDeliveryTime: "平均納期",
    TheSlowest: "最も遅い",
    Fastest: "最速の",
    NumberDefects: "欠陥数",
    NumberOfDefects: "不適切な数量",
    defectRate: "不良品率",
    PurchaseQuantity: "購入数量",
    DefectOccurrenceTime: "悪い時期",
    DefectDescription: "不適切な説明",
    DefectImage: "悪い写真",
    HandlingDecision: "意思決定の処理",
    HandlingCompletionTime: "処理完了時間",
    AdjustedQuantity: "調整数量",
    PurchaseUnitPrice: "購入単価",
    AdjustedUnitPrice: "調整後の単価",
    PurchaseHandlingFee: "購入手数料",
    AdjustedHandlingFee: "調整後の手数料",
    AdjustedServiceFee: "調整後のサービス料金",
    AdjustedDomesticShipping: "国内配送料を調整しました",
    SinglePurchaseTotalCost: "購入ごとの合計コスト",
    AdjustedTotalCost: "調整後の総コスト",
    TotalDifference: "合計の差額",
    procurementDetails: "購入詳細",
    procurementQuantity: "購入数量",
    usingLogistics: "物流を利用する",
    porderDetail: "配送依頼詳細",
    SingleBoxUnpacking: "単一ボックスの開梱",
    OneCancellatioBoxes: "ワンクリックで複数のボックスをキャンセル",
    SingleProductCancellation: "単品キャンセル",
    CurrentNumberBoxed: "現在梱包されている箱の数",
    CancelPackingMultipleBoxes: "複数の箱を開梱する",
    ConfirmedWithoutError: "確認済み",
    customizedProducts: "プライベートパレット",
    CreateProduct: "製品を作成する",
    SupplementaryImage: "サブピクチャー",
    ProductDetails: "製品詳細",
    editProduct: "製品の編集",
    singleNote: "単音",
    progressQuantity: "進行中の数量",
    problemProductStatus: "問題のある製品のステータス",
    orderPrioritySequence: "注文の優先順位",
    managementNumber: "お客様の製品管理番号",
    replaceManagementNumber: "変更管理番号",
    beginnerSGuideH5: "初心者向けガイド H5",
    kitAssemblyDetails: "セット内容",
    chatHistory: "チャット履歴",
    messageContent: "メッセージ内容",
    pendingDepositAmountConfirmation: "入金額確認中",
    referrerRegistrationSource: "紹介者 - 登録元",
    batchReviewProcess: "一括レビュー",
    productDataAnalysis: "製品データ分析",
    timeFilterSelection: "時間フィルター",
    productData: "製品データ",
    taobaoProcurementTotalAmount: "タオバオでの購入総額",
    taobaoProcurementLinkQuantity: "タオバオ購入リンクの数",
    procurementTotalAmount: "1688購入総額",
    procurementLinkQuantity: "1688 購入リンク数量",
    factoryData: "工場データ",
    numberOfTaobaoFactoriesProcured: "タオバオから購入した工場の数",
    numberOf1688FactoriesProcured: "購入した工場数 1688社",
    confidentialProductList: "プライベートパレット",
    numberOfStoresCrawled: "キャプチャされた店舗の数",
    numberOfConfidentialProductLinksCrawled: "キャプチャされたプライベート製品リンクの数",
    orderRankingByProductStatistics: "製品統計による注文ランキング",
    excelExport: "EXCELエクスポート",
    ranking: "ランキング",
    factoryName: "工場名",
    factoryLink: "ファクトリーリンク",
    platformAffiliation: "プラットフォーム",
    lastPurchaseDate: "最終購入日",
    historicalPurchaseCount: "過去の購入回数",
    totalHistoricalPurchaseAmount: "過去の購入総額",
    rankingByFactoryOrderStatistics: "工場統計による受注ランキング",
    productName: "商品名",
    oneClickImportProducts: "ワンクリックで商品をインポート",
    productCategoryManagement: "商品分類管理",
    inventoryManagement: "パレット管理",
    batchAddProductsToInventory: "商品を数回に分けてパレットに入れる",
    associatedInventory: "所属するパレット",
    supplierName: "サプライヤー名",
    createFirstLevelCategory: "第 1 レベルのカテゴリを作成する",
    createSecondLevelCategory: "二次カテゴリを作成する",
    classificationyName: "カテゴリ名",
    inventoryConfiguration: "パレット構成",
    inventoryName: "パレット名",
    restrictionCondition: "制限事項",
    useByDefault: "デフォルトで使用される",
    addNewInventory: "新しいパレットを追加",
    createAttribute: "プロパティの作成",
    generateSkuCombination: "SKUの組み合わせを生成する",
    imageUpload: "画像のアップロード",
    addValue: "付加価値",
    selectInventoryToJoin: "追加するパレットを選択してください",
    privateInventoryProductOneClickImport: "ワンクリックでプライベートパレット製品をインポート",
    creationManagementDesignation: "システム管理番号の生成",
    storeAuthorization: "ストアの承認",
    userNameOrID: "顧客名/ID",
    storeType: "店舗タイプ",
    authorizedStoreId: "正規ストアID",
    storeProducts: "店舗商品",
    replenishmentLinkCount: "補充リンク数量",
    storeAddedDate: "ストア追加日",
    storeFirstAuthorizationDate: "最初の認証日を保存する",
    productUpdateDate: "製品更新日",
    replenishmentLinkLastUpdated: "補充リンクの最新更新時間",
    unbind: "バインドを解除する",
    processProducts: "取り扱い商品",
    disposedProductRemarks: "不用品処分についての注意事項",
    administrativeHandlingPlan: "管理的治療計画",
    businessManagementRemarks: "経営メモ",
    newArrivalReminder: "新しいリマインダー",
    apiOrderCount: "API注文の数",
    apiOrderLatestTime: "API注文の最新時間",
    apiShippingOrderCount: "API配信オーダーの数",
    apiShippingOrderLatestTime: "API配信注文の最新時間",
    productDetailedDescription: "製品詳細説明",
    fuzzySearchByManagementNumber: "管理番号あいまい検索",
    pendingRefundQuantity: "返金される数量",
    modifiedAdditionalServices: "変更後の追加サービス",
    specificProblemDescription: "具体的な問題の説明",
    businessDecisionRemarks: "ビジネス上の意思決定に関するメモ",
    fbaPickingConfirmationRemarks: "FBA（流通）確認備考",
    relatedCompensationOrder: "関連する補償命令",
    refundQuantityConfirmation: "返金数量の確認",
    fbaPickingConfirmation: "FBA（フルフィルメント）確認",
    issueSubmissionDuringSale: "販売中に質問をする",
    realTimeQuantity: "リアルタイム数量",
    productManagementBusinessSummary: "商品管理事業概要",
    historicalProducts: "歴史的な品物",
    pendingBindingLinksCount: "バインドするリンクの数",
    managementNumberCount: "管理番号数",
    maintainedBasicInfo: "基本情報は整備されている",
    basicInfoPendingMaintenance: "基本的な情報は維持する必要がある",
    deactivateManagementNumber: "管理番号を無効化する",
    activateManagementNumber: "管理番号有効",
    batchMaintenance: "一括メンテナンス",
    batchIdentification: "バッチ識別",
    customerProductDataExport: "顧客の製品データをエクスポートする",
    customerProductDataExportAll: "顧客製品データのエクスポート (全量)",
    identifier: "ロゴ",
    selectedManagementNumbers: "選択された管理番号",
    oneClickSubmission: "ワンクリックで送信",
    editRefundQuantity: "返金数量編集",
    submitModification: "変更を送信する",
    serialNumberStatusFilter: "数値ステータスフィルター",
    optionDescription: "オプションの説明",
    createMajorCategory: "大まかなカテゴリを作成する",
    createOptionDescription: "オプションの説明を作成する",
    majorCategoryName: "大きなカテゴリ名",
    categoryDescription: "分類の説明",
    projectName: "プロジェクト名",
    questionMarkIconDescription: "疑問符アイコンの説明",
    pageFixedDisplayDescription: "ページ固定表示命令",
    regularMemberFeeDescription: "通常会費のご案内",
    fixedRateMemberFeeDescription: "固定会費のご案内",
    svipFeeDescription: "SVIP の充電手順",
    optionImage: "オプションの写真",
    majorCategory: "大きなカテゴリ",
    editOptionDescription: "オプションの説明を編集する",
    attachmentDownload: "添付ファイルのダウンロード",
    openingCount: "開封数",
    wechatAuthorization: "WeChatの認証",
    wechatLogin: "WeChatログイン",
    fullNameInRomanji: "フルネーム（ローマ字表記）",
    editFullNameInRomanji: "ローマ字でのフルネーム編集",
    amazonDelivery: "納品数量",
    shelfManagement: "棚管理",
    shelfRemarks: "棚の備考",
    storageLocationManagement: "在庫位置管理",
    layerNumber: "庫位番号",
    batchSetStorageLocations: "倉庫の場所をバッチで設定する",
    printStorageLocationLabels: "位置マークを印刷する",
    numberOfLayers: "レイヤー数",
    numberOfStorageLocationsInLayer: "このレイヤー ライブラリの桁数",
    setStorageLocation: "場所を設定する",
    printOptions: "印刷オプション",
    loginToView: "ログインが表示される",
    currentPrice: "現在の価格",
    serviceOperation: "サービス運営",
    operationQuantity: "操作数",
    clothLabelProcessing: "布ラベル加工",
    noNeedToGetTrackingNumber: "物流番号を取得する必要はありません",
    batchPrint: "バッチ印刷",
    enterpriseWechatAuthorization: "エンタープライズ WeChat 認証",
    deliveryOrderAdjustment: "配達注文の調整",
    addLabelText: "ラベルテキストの追加",
    statusChange: "ステータス変更",
    foldBox: "折りたたみボックス",
    recommendedProducts: "推奨される製品メンテナンス",
    displayImages: "写真を表示する",
    earliestOperationTime: "最も早い稼働時間",
    settlement: "外国為替の決済",
    settlementNumber: "決済番号",
    settlementAmount: "為替決済金額",
    payeeWiseAccountInfo: "受取人 Wanlihui VA アカウント情報",
    payerWiseAccountInfo: "支払者 Wanlihui VA アカウント情報",
    settlementAdditionalInfo: "外国為替決済に関する追加情報",
    settlementNotificationTime: "為替決済通知時間",
    settlementSuccessTime: "外国為替決済成功時刻",
    settlementStatus: "外国為替決済状況",
    moveUp: "上に移動",
    moveDown: "下に移動",
    translationEditing: "翻訳エディター",
    getProductInfo: "製品情報を取得する",
    currentArrivalQuantity: "今回の入荷数",
    spotCheck: "スポットチェック",
    taskContentConfiguration: "タスク内容の設定",
    taskList: "タスクリスト",
    autoGenerateTasks: "タスクを自動生成する",
    taskType: "タスクの種類",
    specificRequirements: "特定の要件",
    taskTypePreview: "タスクタイプのプレビュー",
    createSpecificRequirements: "特定の要件を作成する",
    specificRequirementsReferenceStandard: "特定の要件の参照規格",
    lastModifiedTime: "最終変更時刻",
    typeName: "型名",
    taskGroup: "タスクグループ",
    createTask: "タスクの作成",
    executor: "執行者",
    taskNumber: "タスク番号",
    personInCharge: "担当者",
    spotCheckResult: "スポットチェック結果",
    confirmationStatus: "ステータスを確認する",
    spotCheckItems: "抜き取り検査項目",
    taskStatus: "タスクのステータス",
    viewAll: "すべて見る",
    addCompensation: "新たな補償",
    remindExecutor: "実行者に催促する",
    closeTask: "タスクを閉じる",
    emailBlockConfig: "メール受信設定",
    isEnabled: "オンにするかどうか",
    executorRatioPendingTasks: "実行者比率 - 未完了のタスクの数",
    currentGenerationConditions: "電流発生条件",
    taskResultPreview: "タスク結果のプレビュー",
    isAbnormal: "異常ですか？",
    imageRecords: "ピクチャーレコード",
    remarkRecords: "ノートレコード",
    closeReason: "閉店の理由",
    pleaseSelectTaskType: "タスクの種類を選択してください",
    taskDeadline: "タスクの期限",
    messageRecipient: "メッセージプッシャー",
    spotCheckItemSelection: "スポットチェック項目の選択",
    specificSpotCheckRequirements: "特定のスポットチェック要件",
    selectSpotCheckContentFromSystem: "システムからスポットチェックコンテンツを選択します",
    manuallyAdd: "手動で追加",
    currentData: "現在のデータ",
    spotCheckQuantity: "ランダム小切手数量",
    addToTask: "タスクに参加する",
    specificRequirementsSelection: "特定の要件を選択してください",
    manuallyAddRequirements: "要件を手動で追加する",
    shipmentQuantity: "出荷数",
    logisticsInformation: "物流情報",
    taskGenerationRule: "タスク生成ルール",
    addNewRule: "新しいルールを追加",
    generationCondition: "条件の生成",
    historicalAfterSale: "過去のアフターサービスの有無",
    triggerCondition: "トリガー条件",
    highAmountTrigger: "高額（単品金額が2000を超える商品）",
    afterSaleHistoryTrigger: "アフターサービス履歴（過去にアフターサービスがあった商品）",
    oemTrigger: "OEM（注文タイプがOEMの商品）",
    manualGenerationTrigger: "手動生成（手動で生成されたタスク）",
    deleteThisMethod: "このメソッドを削除します",
    saveChanges: "変更を保存する",
    generationProbability: "生成確率",
    modifyRule: "ルールの変更",
    deliveryOrderType: "配達注文タイプ",
    optionMatching: "オプションの一致",
    deliveryOrderShipmentAmount: "配送依頼の出荷金額",
    spotCheckBoxes: "ランダムにボックスにチェックを入れる",
    generationTime: "生成時間",
    modifyProductNumber: "製品番号を変更する",
    rakumartOverseasWarehouseConsolidation: "RAKUMART海外倉庫集約",
    selfConsolidation: "自律的な統合",
    selfConsolidationAuthorizationSettings: "Autonomous Consolidationの認可設定",
    selfConsolidationAuthorization: "独立した統合認可",
    rkOverseasWarehouseConsolidationAuthSettings: "RK海外倉庫おまとめ承認設定",
    rakumartOverseasWarehouseAuthorization: "楽マート海外倉庫認可",
    additionalQuantity: "追加数量",
    basePriceConfigurationList: "最下位価格構成リスト",
    basePrice: "予約価格",
    basePriceEntry: "予約価格を入力します",
    attributeCombination: "属性の組み合わせ",
    agreedBasePrice: "契約最低価格",
    isRefundVoucher: "返金引換券はありますか？",
    finalReview: "最終レビュー",
    internalConfirmation: "社内確認",
    pendingJapanReview: "日本での審査待ち",
    japanReviewRemarks: "日本レビューノート",
    pendingMinisterConfirmation: "部長確認待ち",
    ministerConfirmation: "部長確認",
    requestReReview: "レビュー用のファイル",
    supplementalScreenshots: "追加のスクリーンショット",
    reReviewReason: "見直しの理由",
    startReReview: "レビューを開始",
    reReview: "レビュー",
    problemDiscoveryToResolutionDuration: "問題発見-解決の所要時間",
    durationRating: "問題発見-解決の所要時間",
    durationRatingDescription: "所要時間の評価は1星から5星まで、星が多いほど時間が短く、早く解決したことを示す",
    ratingStatus: "評価ステータス",
    specialLabelPrinting: "特殊印刷",
    lookContent: "コンテンツを見る",
    pickingWorkStatus: "配布作業状況",
    depositWithdrawalModification: "入金と出金の変更",
    applyForDepositWithdrawalModification: "入出金変更申請",
    withAttachedImages: "添付写真",
    depositWithdrawalName: "入出金名",
    reviewTime: "レビュー時間",
    reject: "拒否する",
    depositWithdrawalType: "入金と出金の種類",
    depositWithdrawalAmount: "入出金金額",
    modifiedAmount: "変更金額",
    submitApplication: "申請書を提出する",
    confirmModification: "変更を確認する",
    rejectApplication: "申請を拒否する",
    reviewRemarks: "審査備考",
    overseasWarehouseBarcode: "海外倉庫バーコード",
    crossGroupOrderAdjustment: "グループ全体で注文を調整する",
    crossGroupDeliveryOrderAdjustment: "グループ間で配達注文を調整する",
    temporaryOrder: "仮注文",
    orderExpand: "注文を展開",
    customColumns: '表示列設定',
    customOperations: '操作ボタン設定',
    showAllOperations: 'すべて表示',
    withdrawTranslation: '翻訳を取り消す',
    showAllColumns: 'すべて表示',
    orderCollapse: "注文を折りたたむ",
    autoAddMadeInChina: "中国製を自動的に追加",
    productManagementSyncData: "商品管理データ同期",
    requireAutoSpotCheck: "自動スポットチェックが必要です",
    smallOrderMinFee: "小顧客手数料",
    auxiliaryMaterials: "賦形剤",
    materialType: "賦形剤の種類",
    materialName: "賦形剤名",
    materialNameTrans: "添加剤名の翻訳",
    productManagementNumber: "商品管理番号",
    materialTypeSetting: "添加剤カテゴリーの設定",
    materialAdd: "添加剤の登録",
    isIncludedInAssessment: "評価に含めるかどうか",
    productLabelDownload: "製品ラベルのダウンロード",
    productLabelDownloadFailed: "製品ラベルのダウンロードに失敗しました",
    outerLabelDialogTitle: "配送ラベルPDFをダウンロード",
    outerLabelFormatTip: "ファイルのレイアウト形式を選択",
    outerLabelA4Title: "1ページ6枚",
    outerLabelA4Description: "A4ラベル用紙向け、1枚に6ラベル",
    outerLabelSingleTitle: "1枚",
    outerLabelSingleDescription: "1ページに配送ラベル1枚、標準ラベル用紙サイズ（熱転写印刷が必要です）",
    outerLabelStartPosition: "最初のページの印刷開始位置を指定",
    outerLabelSelectedPosition: "現在の選択：{position}番",
    outerLabelConfirmDownload: "ダウンロードを確認",
    outerLabelStartPositionRequired: "1～6の印刷開始位置を入力してください",
    shippingLabelDownload: "配送ラベルのダウンロード",
    businessFollowUpRemarks: "業務命令メモ",
    whetherIncludedInAssessment: "評価に含めるかどうか",
    ordersNotArrived: "未配達の注文",
    purchaseCompletionTime: "購入完了時間",
    replaceLinkEdit: "リンク編集を置き換える",
    customerOrderAttributes: "顧客注文の属性",
    replaceLink: "リンクを置き換える",
    originalLinkData: "生のリンクデータ",
    currentLinkData: "現在のリンクデータ",
    pendingFollowUpLogisticsList: "フォローアップ対象の物流リスト",
    logisticsDeliveryTime: "物流番号 納期",
    logistics1688SignTime: "物流番号 1688 署名時間",
    originalLink: "差し替え前のリンク",
    replacedLink: "置き換え後のリンク",
    originalPriceCalculationOption: "元の価格計算オプション",
    largeGoodsNumber: "バルク数量",
    additionalServicesName: "追加サービス名",
    airlineFare: "航空運賃単価",
    shipFare: "ボートの単価",
    whetherReviewed: "見直されましたか?",
    originalPriceCalculationSingleDomesticShippingFee: "国内送料を計算するための元の価格",
    presetTaskList: "デフォルトのタスクリスト",
    taskBasicInformation: "タスクの基本情報",
    bulkShippingCost: "バルク品の場合の単一配送料",
    bulkQuotation: "バルク単価",
    presetTask: "デフォルトのタスク",
    presetTaskCheck: "事前のスポットチェック",
    appendProduct: "追加商品",
    businessTranslationRemarks: "ビジネス翻訳ノート",
    autoAskPrice: "自動問い合わせメッセージ設定",
    labelPrinting: "マーク印刷",
    generateSupplierOrder: "サプライヤーの注文を生成する",
    CWGroupBatchOperation: "CWグループ一括運転",
    confirmOperation: "アクションの確認",
    operationType: "操作の種類",
    pullPeople: "人を引っ張る",
    kickOut: "誰かを蹴る",
    chooseCWGroup: "CWグループを選択してください",
    chooseUser: "人を選択する",
    chooseCustomerChatGroup: "顧客チャットグループを選択してください",
    adminName: "販売員の名前",
    quoteData: "見積データ",
    realTimePrice: "リアルタイム価格",
    isReplace: "買い戻すかどうか",
    refundedPendingConfirmation: "払い戻しは確認待ちです",
    hasRefundImage: "証明書はありますか？",
    isAfterSale: "アフターサービスを開始するかどうか",
    afterSaleCompletionTimeIn1688: "1688 アフターセールス完了時間",
    refundedAmountIn1688: "1688 返金商品金額 CNY",
    incomeAccount: "収入口座 (Alipay/銀行)",
    arrivalStatus: "入金状況",
    refundArrivalTime: "払い戻し到着時間",
    auditStatus: "レビュー状況",
    financialAuditRemark: "財務レビューメモ",
    afterSaleOrderNumber: "アフターセールス注文番号",
    customerOrderNumber: "お客様の注文番号",
    refundQuantity: "返金数量",
    problemProductRefundedAmountIn: "問題のある商品の返金金額 (CNY)",
    problemProductPurchaseProcessingCompletionTime: "問題商品購入処理完了時間",
    refundVoucher: "払い戻し伝票",
    isAfterSaleIn1688: "1688この取引番号でアフターサービスが開始されるかどうか?",
    replenishmentOrder: "補充注文",
    registrationInformation: "登録情報",
    replenishmentTransactionNumber: "補充取引番号",
    totalReplenishmentAmountInCNY: "総買戻し額 (CNY)",
    detailedExplanation: "詳細な説明",
    isInternalClaimOrClaimNumber: "内部補償/補償注文番号はありますか?",
    informationSupplementation: "情報補足",
    audit: "レビュー",
    replenishmentRegistration: "再購入登録",
    isInternalClaim: "内部補償はありますか？",
    orderDetailId: "注文詳細ID",
    registration: "登録する",
    aftersaleIssueCreate: "問題登録",
    badNumberTotalAmount: "不良債権総額（元）",
    afterSaleProblemDescription: "アフターセールスの問題の説明",
    confirmDetail: "詳細を確認する",
    businessInitialProcessing: "事前の事務処理",
    classLeaderDecision: "課長の決断",
    businessFinalProcessing: "最終的な事務処理",
    problemClassification: "問題の分類",
    relatedAfterSaleOrder: "関連するアフターセールス注文",
    issueCreate: "問題登録",
    shippingLabelSpec: "納入標準仕様の選択",
    download: "ダウンロード",
    autoInquiryProductMessageSettings: "自動問い合わせ情報設定",
    defaultSettings: "自動問い合わせメッセージ設定（デフォルト）",
    batchDeleteSettings: "設定を一括削除する",
    addSingleCustomerSettings: "単一顧客設定を追加する",
    messageSettings: "メッセージ設定",
    customerMessageSettings: "お客様設定メッセージ",
    chooseCustomer: "顧客を選択してください",
    pleaseChooseCustomer: "お客様を選択してください",
    returnAndExchange: "返品または交換",
    translationTimeStart: "翻訳時間が始まります",
    translationTimeEnd: "翻訳時間が終了します",
    proposeStartTime: "開始時間を提案する",
    proposeEndTime: "終了時間を提案する",
    regularWarehouse: "通常倉庫",
    longTermStorageWarehouse: "長く使える倉庫",
    boxNums: "箱番号",
    warehouseInTimeStart: "保管時間 - 開始",
    warehouseInTimeEnd: "保管時間 - 終了",
    warehouseStorageDays: "保管日数",
    exportInventory: "在庫のエクスポート",
    transferToRegularWarehouse: "通常の商品倉庫へ移送",
    packBy: "梱包オペレーター",
    customerCorrespondingPerson: "顧客対応担当者",
    pendingPaymentWarehouseFee: "保管料お支払い（元）",
    warehouseFeePaid: "保管手数料発生（元）",
    boxInnerGoodsValue: "箱の中の商品の価値（元）",
    warehouseAge: "保管日数",
    warehouseInTime: "保存期間（保存期間）",
    boxSize: "箱のサイズ",
    boxInnerGoodsNum: "箱の中のアイテムの数",
    boxInnerSKUNum: "ボックス内の SKU の数",
    expandCollapse: "拡大する",
    transferOrder: "転送命令",
    inventoryTransfer: "株式譲渡",
    mergeTransferOrder: "転送オーダーの統合",
    cancelTransferOrder: "転送のキャンセル",
    charge_wms: "梱包完了し入庫待ちです",
    packCompleteTime: "梱包完了時間",
    subOrderStatus: "モナドステータス",
    entireOrderOperationRemark: "注文全体の操作メモ",
    targetWarehouse: "対象倉庫",
    currentWarehouse: "現在の製品が置かれている倉庫",
    proposeTransferTime: "乗り換え時間を提案する",
    operationProductQuantity: "操作商品数量",
    operationProductSerialNumber: "操作商品番号",
    pendingTransferOrder: "パッケージ化される転送オーダー",
    transferOrderDetails: "転送注文の詳細",
    operationProductRemark: "単独運転時の注意事項",
    transferOrderQuantity: "転送数量",
    transferToLongTermStorageWarehouse: "長期保管倉庫へ移送",
    movableQuantity: "移動できるライブラリの数",
    singleOperationRemark: "単独運転時の注意事項",
    uploadToLongTermStorageWarehouse: "長期保管倉庫へ棚出し",
    longTermStorageFee: "長期保管料",
    regularStorageFee: "通常の保管料金",
    lastModifiedTimes: "最終変更時刻",
    currentEffectiveTimes: "現在の有効時間",
    costManagement: "経費管理",
    addWarehouseFeeConfiguration: "新しい請求を追加する",
    addRegularStorageFee: "新しい請求を追加する",
    addConfiguration: "新しい構成",
    calculationInterval: "間隔を計算する",
    addValuationInterval: "価格帯の拡大",
    addValuationIntervalTip: "注: 間隔は、左より大きく、右以下を意味します。終了値を入力しない場合、デフォルトで上限は無限大となります。",
    customerLevel: "ランク",
    threeSidesSum: "三方和平",
    priceInYen: "価格（円）",
    priceCategory: "価格カテゴリー",
    addRow: "新しい行を追加",
    confirmSubmit: "提出の確認",
    pleaseSelectClientLevel: "顧客レベルを選択してください",
    pleaseFillPriceRange: "価格帯を入力してください",
    pleaseSelectTime: "発効日を選択してください",
    confirmAddConfiguration: "この構成情報を追加してもよろしいですか?",
    ddConfiguration: "新しい構成",
    updateConfiguration: "構成を更新する",
    confirmUpdateConfiguration: "この構成情報を更新してもよろしいですか?",
    longTermStorageWarehouseBill: "長期倉庫請求書",
    regularWarehouseBill: "通常の倉庫請求書",
    billNumber: "請求書番号",
    feeBoxNumber: "課金可能ボックス数",
    productNumber: "製品数量",
    longTermStorageFeeTotalAmount: "長期保管料金の総額",
    regularStorageFeeTotalAmount: "通常保管料金の合計",
    billDate: "請求日",
    totalAmount: "総費用",
    longTermStorageFeeName: "長期保管料",
    regularStorageFeeName: "通常の保管料金",
    dimension: "寸法(cm)",
    goodsCount: "ボックス内の SKU の数",
    goodsNumber: "箱の中のアイテムの数",
    expand: "拡大する",
    transferOrderNumber: "転送オーダー番号",
    packedQuantity: "梱包された箱の数",
    transferQuantity: "転送数量",
    uncompleted: "未完了",
    completed: "完了",
    printBoxLabel: "プリントボックスマーク",
    submitToAdmin: "梱包が完了し、管理機関に提出されました",
    modifyBoxRules: "ボックスの仕様を変更する",
    startPacking: "荷造りを始める",
    inStockQuantity: "在庫数",
    takeOutQuantity: "出荷数量",
    otherBoxesHavePackedNum: "その他の箱の梱包数",
    moveBoxQuantity: "移動量",
    intoLongTermStorageWarehouse: "長期保管倉庫へ",
    rangeStartMustGreaterThanEnd: "間隔の開始値は間隔の終了値より大きくなければなりません",
    rangeEndMustGreaterThanStart: "間隔の終了値は間隔の開始値より大きくなければなりません",
    cancelPacking: "開梱する",
    batchExpressUpdate: "返品物流番号をバッチで入力します",
    singleCheck: "単一検証",
    abnormalArrivalRegistration: "到着例外登録",
    originalInboundOrderNumber: "元の受付番号",
    arrivalWarehouseMethod: "到着方法",
    inboundType: "倉庫タイプ",
    trackingNumber: "追跡番号",
    proposeTime: "提出時間",
    assignmentOrderNumber: "配布注文番号",
    thirdPartyOrderNumber: "サードパーティの注文番号",
    overseasWarehouseAbnormalOrderNumber: "海外倉庫への異常な注文番号",
    productQuantity: "製品数量",
    numberOfSKUs: "SKU数",
    preServiceSet: "前処理設定",
    fbaPreOperator: 'FBA前処理担当者',
    fbaPreOperatorLeader: '検品グループリーダー',
    fbaPreOperatorFba: 'FBA担当者',
    fbaPreOperatorInspector: '検品担当者',
    fbaPreOperatorAllLeader: '検品グループリーダーを全選択',
    fbaPreOperatorAllFba: 'FBA担当者を全選択',
    fbaPreOperatorAllInspector: '検品担当者を全選択',
    fbaPreAllEnable: 'FBA前処理を一括設定',
    fbaPreAllDisable: 'FBA前処理を一括解除',
    requiredCompletionTime: "所要完了時間",
    serviceOrderType: "サービス注文タイプ",
    totalNeedToOperate: "必要な合計操作",
    purchaseInformation: "購入情報",
    operationRequirements: "動作要件",
    inspectionLeaderRemark: '検品リーダー備考',
    operationPersonnelRemark: '作業担当者備考',
    goodsSpecification: "貨物仕様",
    charge: "チャージ",
    goodsSpecifications: "貨物仕様",
    operationContent: "操作内容",
    oneClickExpand: "一括展開",
    oneClickCollapse: "一括折りたたみ",
    enterTransactionOrLogisticsNumber: "取引番号または物流番号を入力してください",
    operationContentNeedsOperationQuantity: "操作内容 - 必要な操作数",
    forwarder: "提案者",
    totalNeedsOperation: "必要な合計操作",
    updateReason: "変更理由",
    serviceType: "サービス注文タイプ",
    mechanicalOperationOrder: "機械操作順序の概要",
    fabricLabelOperationOrder: "ラベル付け操作命令の概要",
    FBAOperationOrder: "FBA業務の注文概要",
    photographyOrder: "撮影オペレーションシート概要",
    viewServiceOrderDetail: "サービス注文の詳細を表示する",
    updateQuantity: "数量を変更する",
    updateRemark: "備考の変更",
    directCompletion: "そのまま配布完了",
    businessRemarkographyOrderRemark: "ビジネス写真撮影注文注意事項",
    reGenerateInboundPlan: "ギフトプランを再生成する",
    reGenerate: "再生する",
    reGenerateSuccess: "報酬プランが正常に生成されました。",
    deliveryFollowUpRemarks: "配布・注文に関する注意事項",
    openedQuantity: "開封数量",
    viewQuestionnaire: "アンケートを見る",
    apiManagement: "API管理",
    purchasePayCheckList: "トランザクション番号プラットフォーム支払い比較リスト",
    processed: "加工済み",
    allOfTheComparison: "すべてを比較",
    platformPaymentStatus: "プラットフォームの支払いステータス",
    fromPlatform: "ソースプラットフォーム",
    clientName: "顧客名",
    amountMatchStatus: "金額照合ステータス",
    sorting: "番号ソート",
    totalQuantity: "取引番号内の商品の数量",
    customer: "お客様",
    createTime: "作成時間",
    lastCheckCheckTime: "最終チェック時間",
    totalPurchaseAmount: "",
    handleStatus: "処理状況",
    totalPayableAmount: "顧客の支払総額",
    unmatchedReason: "不一致の理由",
    totalPaymentAmount: "支払総額",
    buyAccount: "買付アカウント",
    purchaseCost: "購入費用を記入",
    actualPaymentAmount: "1688 買掛金",
    financialRemark: "財務メモ",
    generatePaymentLinks: "支払いリンクをバッチで生成する",
    markProcessed: "マーク処理",
    areYouSureToMarkProcessed: "選択した注文を処理対象としてマークしますか?",
    purchasePayCheckDeal: "購入・支払い比較処理",
    areYouSureToPurchasePayCheckDeal: "トランザクション番号を処理済みとしてマークしますか?",
    areYouSureToGeneratePaymentLinks: "バッチ生成の支払いリンクによって選択された注文を確認しますか?",
    purchaseNoNotInSystemList: "異常取引番号追跡リスト",
    isPayable: "有料ですか",
    worldfirstCheckList: "出金データ異常",
    purchaseChengBen: "調達コスト",
    serviceOrderSplit: "サービス注文の分割",
    fingerprintCollection: "指紋採取",
    supplementalMaterials: "補足情報",
    purchasePayCheckPurchaseList: "支払いのフォローアップが保留中",
    depositTime: "入金時間",
    apiBindingIdentifier: "APIバインディング識別子",
    businessTemporaryRemarks: "業務に関する一時覚書",
    manualOrder: "手動発注",
    addGoods: "新しい注文をする",
    personAdjustment: "人事調整",
    orderTypeEdit: "注文タイプの編集",
    deleteOrderRemark: "注文メモを削除する",
    pleaseEnterTheDeleteReason: "削除理由を入力してください",
    immediateAdjustment: "今すぐ調整してください",
    relatedDeliveryOrder: "関連配送依頼",
    andSingle: "合併",
    productInformationEntry: "商品情報入力",
    productInfoRecordSettings: "製品情報記録設定",
    productInfoTask: "製品情報タスク",
    needRecord: "記録する必要がある",
    noNeedRecord: "録音する必要はありません",
    serviceOperationDuration: "サービス稼働時間",
    goodsWeightSize: "製品重量サイズ",
    taskExecutionOrder: "タスクの実行順序",
    taskRequirements: "ミッション要件",
    commodityInformationEntry: "ビジネス商品情報入力フォーム",
    assignmentCommodityInformationEntry: "頒布商品情報入力フォーム",
    editExecutor: "実行者の変更",
    businessCommodityInformationEntry: "ビジネス商品情報入力フォーム",
    normalInspectionOperationDuration: "通常検査運転時間（単独）",
    additionalServiceOperationDuration: "付加サービス（単独サービス稼働時間）",
    repurchaseCount: "買戻し回数",
    transferBox: "転送ボックス",
    packDateStart: "データベース転送の開始時刻を提案します",
    packDateEnd: "データベース転送の終了時刻を提案する",
    transferApplyBy: "データベース移転提案者",
    distributionBoxRemark: "宅配ボックスについてのご注意",
    businessBoxRemark: "ビジネスボックス備考",
    administrativeExtractionTime: "管理上の引き出し時間",
    warehouseAgeMin: "倉庫築年数の最小値",
    warehouseAgeMax: "倉庫築年数の最大値",
    cancelHandoverApplication: "引継ぎ申請をキャンセルする",
    takeOutToDistribution: "配布用にテイクアウト",
    warehouseAgeTitle: "保管期間",
    storedDays: "保管日数",
    orderNumberMash: "注文番号/シリアル番号",
    pendingDistributionConfirm: "配送確認保留中",
    waitPutIntoLongTermStorageWarehouse: "長期保管倉庫への入庫待ち",
    waitTakeOutFromLongTermStorageWarehouse: "長期保管倉庫からの搬出待ち",
    pendingDistributionShelf: "配達待ち",
    collapse: "閉じる",
    red: "赤",
    temporaryArea: "ステージングエリア",
    outOfShelfApplyBy: "出庫申請者",
    outOfShelfApplyTime: "納期",
    cancelTransfer: "転送のキャンセル",
    confirmSubmitToAdministration: "管理者への提出を確認する",
    uploadToRegularWarehouse: "通常商品倉庫に棚に並べる",
    directPackingBox: "箱に直接梱包する",
    packCompleteWaitShip: "梱包完了し発送準備完了です",
    packTime: "梱包時間",
    boxStatus: "ボックスの状態",
    unshippedOrder: "未発送の注文",
    locationInfo: "位置情報",
    customerOrderRemark: "お客様の注文メモ",
    distributionPackRemark: "配送・梱包時の注意点",
    salesPackRemark: "販売員の梱包に関するコメント",
    returnToPacking: "ボックスに戻る",
    personnelScope: "範囲",
    shelfType: "場所の種類",
    normalShelf: "通常の場所",
    chargeShelf: "長く使える倉庫",
    inboundDate: "保管日",
    outboundDate: "発送日",
    packCompleteInboundTime: "梱包完了時間（入庫）",
    belongingPorder: "所属配送依頼",
    proposedToPorder: "配達注文を送信しました",
    convertFreightToOrderBoxConfirm: "現在の配送依頼内の商品を長期保管倉庫へ移しますか？<br>確認後、倉庫移動引継書が作成され、管理担当者が移動・棚入れ作業を行います。<br>確認後は元に戻せません。",
    confirmProposeTransfer: "ライブラリを移転する提案を確認する",
    noTransferableBox: "現在の配送依頼には移動可能な箱がありません",
    longTermStorageFeeBill: "長期保管料金請求書",
    longTermStorageFeeConfiguration: "長期保管料金設定",
    warehouseFeeTotalAmount: "保管料の金額",
    warehouseFeeName: "保管料",
    materialList: "賦形剤一覧",
    materialOperation: "副資材操作",
    createMaterial: "副資材を作成",
    selectOneProductToCreateMaterial: "副資材を作成する商品を1件選択してください",
    transactionLogisticsOperation: "取引/物流番号操作",
    markAsMaterial: "商品を副資材としてマーク",
    confirmMarkAsMaterial: "副資材としてマーク",
    confirmMarkSelectedAsMaterial: "選択した商品を副資材としてマークしますか？既に副資材が紐付けられている商品はマークできません。内容を確認してから操作してください。",
    cancelMaterialMark: "副資材マークを解除",
    confirmCancelMaterialMark: "チェックした商品の副資材マークを解除しますか？",
    confirmChangeMaterialConsume: "消費点数を変更しますか？変更後、商品の出荷時に新しい消費点数に基づいて副資材在庫が引き落とされます。",
    bindMaterialUsage: "副資材使用を紐付け",
    pleaseSelectMaterial: "副資材を選択してください",
    customerIdRequired: "顧客IDを入力してください",
    boundMaterialCannotMark: "副資材を紐付け済みの商品は副資材としてマークできません",
    markedMaterialCannotBind: "副資材としてマーク済みの商品には副資材を紐付けできません",
    materialRelationConflict: "商品を副資材としてマークし、同時に副資材を紐付けることはできません",
    customerNameOrID: "顧客名/ID",
    materialId: "添加剤ID",
    noStock: "在庫切れ",
    stockInsufficient: "在庫不足",
    stockSufficient: "十分な在庫",
    suggestReplenishment: "補充をお勧めします",
    actualStockQuantity: "実際の在庫数",
    expectedConsumptionQuantity: "消費量の目安",
    expectedReplenishmentQuantity: "補充目安量",
    expectedConsumption: "推定消費量",
    pointsPerSet: "点/セット",
    materialInOrder: "賦形剤が配置されている場所の順序",
    remainingPoints: "残りポイント",
    point: "ポイント",
    materialEdit: "編集",
    confirmDeleteMaterial: "この賦形剤を削除してもよろしいですか?",
    materialDetail: "賦形剤の詳細",
    materialInfo: "情報",
    uploadMainImage: "メイン画像をアップロードする",
    defaultConsumption: "デフォルトの消費量",
    materialDocumentFiles: "情報ファイル",
    boundOrderPlanList: "紐付け済み商品管理番号",
    batchBind: "一括紐付け",
    batchBindOrderPlan: "注文プランを一括紐付け",
    orderPlanTagNo: "プランラベル番号",
    orderPlanRemark: "業務備考キーワード",
    boundMaterialList: "紐付け済み副資材",
    selectAll: "すべて選択",
    boundOrderList: "オーダーバウンド",
    markedProductList: "特定された製品",
    singleConsumption: "シングル",
    expectedValue: "予想される",
    unmark: "リフト",
    confirmUnmarkMaterial: "この製品の付属品のラベルを削除してもよろしいですか?",
    orderBindMaterialUsage: "オーダーバインディングアクセサリの使用",
    actualPurchaseQuantity: "実際の購入数",
    shippedQuantity: "出荷された商品の数",
    estimatedAvailableQuantity: "利用可能数の目安",
    consumptionPerSet: "1セットあたりの消費ポイント",
    estimatedConsumptionPoints: "ポイント消費目安",
    unbindMaterial: "バインドを解除する",
    confirmUnbindMaterial: "紐付けを解除すると、この商品では副資材が引き落とされなくなります。紐付けを解除しますか？",
    stockInfo: "在庫情報",
    estimatedAutoConsumptionRecord: "推定自動消費記録",
    systemAutomaticUsageRecord: "システムの自動使用記録",
    consumptionDetail: "消費量の詳細",
    porderSn: "配送番号",
    consumedPoints: "ポイントを消費する",
    returnedToWarehouse: "倉庫に戻る",
    stockIn: "倉庫",
    otherInfo: "その他の情報",
    pleaseEnterMattersNeedingAttention: "メモを入力してください",
    editMaterialName: "賦形剤名の変更",
    pleaseUploadImage: "画像をアップロードしてください",
    recordTime: "時間",
    confirmDeleteMaterialImage: "この画像を削除してもよろしいですか?",
    confirmDeleteMaterialFile: "このファイルを削除してもよろしいですか?",
    cancelOutboundApplication: "アウトバウンド申請をキャンセルする",
    productWeightEntry: "製品重量入力",
    platformBillList: 'プラットフォーム請求書',
    platformBillOrderId: '取引番号',
    platformBillCreateTime: '取引作成時間',
    platformBillCurrency: '通貨',
    platformBillDisplayType: '表示タイプ',
    platformBillDirection: '資金方向',
    platformBillTransactingPart: '取引相手',
    platformBillTransactionId: '取引ID',
    platformBillAccountId: '口座ID',
    platformBillType: '取引タイプ',
    platformBillDescription: '取引説明',
    platformBillTransactionTime: '取引発生時間',
    platformBillRunningBalance: '取引後残高',
    platformBillFeeExport: '請求費用エクスポート',
    platformBillFeeExportFail: '請求費用のエクスポートに失敗しました',
    platformBillAmountTotal: '金額合計',
    platformBillServiceFeeTotal: '手数料合計',
    platformBillOrderSnPlaceholder: '注文番号を入力してください',
    platformBillOrderIdPlaceholder: '取引番号を入力してください',
    platformBillDisplayTypePlaceholder: '表示タイプを入力してください',
    pleaseSelectBillingType: '請求書タイプを選択してください',
    pleaseSelectDateRange: '開始時間と終了時間を選択してください',
    platformBillAccountCenter: '口座センター',
    chinaAccounts: '中国口座',
    japanAccounts: '日本口座',
    accountCenterAccountUnit: '口座',
    hideAccountBalance: '残高を非表示',
    showAccountBalance: '残高を表示',
    accountBalanceUpdatedAt: '更新日時',
    accountCurrencyCny: '人民元',
    accountCurrencyJpy: '日本円',
    productInquiry: '商品問い合わせ',
    inquiryQuestion: '問い合わせ内容',
    inquiryQuestionPlaceholder: '共通の問い合わせ内容を入力してください',
    pleaseEnterInquiryQuestion: '問い合わせ内容を入力してください',
    inquiryRecords: '商品問い合わせ履歴',
    noInquiryRecords: '問い合わせ履歴はありません',
    taskId: 'タスクID',
    refinedAnswers: '抽出された回答',
    noRefinedAnswers: '抽出結果はありません',
    dialogueContent: '会話内容',
    noDialogueContent: '会話内容はありません',
    productManagementV2: '商品管理V2',
    productV2AllProducts: 'すべての商品',
    productV2PendingMaintenance: 'メンテナンス待ち',
    productV2Maintaining: 'メンテナンス中',
    productV2PendingAudit: '審査待ち',
    productV2MaintenanceCompleted: 'メンテナンス完了',
    productV2Normal: '正常',
    productV2Hidden: '非表示',
    productV2Yes: 'はい',
    productV2No: 'いいえ',
    productV2CreateProduct: '商品を作成',
    productV2BatchSubmitAudit: '一括審査提出',
    productV2BatchNoNeed: '一括メンテナンス不要',
    productV2BatchAudit: '一括審査',
    productV2RaiseOrderCheck: '注文チェックを提出',
    productV2ProductName: '商品名',
    productV2ProductInfo: '商品情報',
    productV2PurchaseLink: '購入リンク',
    productV2View: '表示',
    productV2BusinessRemark: '業務備考',
    productV2Maintain: 'メンテナンス',
    productV2SelectProduct: '操作する商品を選択してください',
    productV2ConfirmOperation: 'この操作を実行しますか？',
    productV2EditManagementCode: '商品管理番号を変更',
    productV2EnterManagementCode: '商品管理番号を入力してください',
    productV2CompleteCreateInfo: '顧客と商品管理番号を入力してください',
    productV2Loading: '読み込み中...',
    productV2NoData: '商品データがありません',
    productV2Total: '総計 {total} 件',
    productV2PageSize: '件/ページ',
    productV2PlanSelection: 'プラン選択',
    productV2PurchaseRequirement: '仕入調査要件',
    productV2AllocationRequirement: '出荷要件',
    productV2InspectionRequirement: '検品要件',
    productV2OrderHistory: '注文履歴',
    productV2OrderHistoryTip: '管理番号を登録してメンテナンス後、システムは商品明細IDと属性に基づき、周期ごとに履歴注文データを更新します',
    productV2ViewAll: 'すべて表示>>',
    productV2ManagementCodeStatus: '管理番号ステータス',
    productV2Enabled: '有効',
    productV2ViewPlanId: '表示プランID',
    productV2DeletePrompt: '削除確認',
    productV2DeleteWarning: '選択した商品管理データを削除します。削除後は復元できませんので、慎重に操作してください。',
    productV2SubmitAuditPrompt: '審査提出確認',
    productV2SubmitAuditWarning: '選択した管理番号を一括で審査に提出しますか？',
    productV2RaiseOrderPrompt: '提示',
    productV2RaiseOrderWarning: '以下の管理番号には注文情報が設定されていません。設定後に再度注文を提出してください。',
    productV2PlanMaintain: '販売プラン設定',
    productV2SameCustomerOrder: '注文提出時は同一顧客の管理番号のみ選択できます。',
    productV2SelectedCount: '選択数量',
    productV2SelectedList: '選択済み商品',
    productV2NoSelected: '選択された商品はありません',
    productV2SpuBind: 'SPU紐付け',
    productV2CurrentBoundSpu: '現在紐付け済みSPU:',
    productV2SpuSearchPlaceholder: 'SPU / 名称のあいまい検索',
    productV2CreateSpu: 'SPUを作成',
    productV2SpuName: '名称',
    productV2Bind: '紐付け',
    productV2Unbind: '解除',
    productV2BindNow: '今すぐ紐付け',
    productV2SpuSaveTitle: 'SPU作成 /編集',
    productV2EnterSpu: 'SPUを入力してください',
    productV2EnterSpuName: '名称を入力してください',
    productV2UploadImage: '画像をアップロード',
    productV2SpuDeleteWarning: 'SPUを削除すると、紐付け済みの管理番号はすべて自動解除され、元に戻せません。確認のうえ削除してください。',
    confirmDeletion: '削除を確認',
    // 顧客倉庫リニューアル上部の文言
    warehouseBulkStorage: 'バラ保管',
    warehouseBoxStorage: 'ケース保管',
    warehouseNormalGoods: '通常商品',
    warehouseMaterialGoods: '副資材',
    warehouseSearchItem: '検索項目',
    warehouseOrderSnAsc: '注文番号の昇順',
    warehouseOrderSnDesc: '注文番号の降順（デフォルト）',
    warehouseForSnAsc: '管理番号の昇順',
    warehouseForSnDesc: '管理番号の降順',
    warehouseStorageDaysAsc: '保管日数の昇順',
    warehouseStorageDaysDesc: '保管日数の降順',
    warehouseTagNo: 'ラベル番号',
    warehouseGoodsCode: '商品コード',
    // 顧客倉庫「すべて」一覧の文言
    warehouseStorageInfo: '倉庫保管情報',
    warehouseWmsRemark: '倉庫備考',
    warehouseSubmittedCount: '提出済み数量',
    warehouseAvailableCount: '提出可能数量',
    // 梱包中一覧の項目
    warehousePackingCount: '梱包数',
    // 顧客倉庫配送プレビュー文言
    warehouseDeliveryPreview: '副資材自動追加確認',
    warehouseDeliveryPreviewWarning: '注意：在庫が十分な副資材のみ配送単に自動追加されます。在庫不足の場合は自動計算できません。',
    warehouseShipmentQuantityInvalid: '出荷数は0より大きい整数で入力してください',
    confirmSubmission: '提出を確認',
    // 顧客倉庫の下部一括操作バー文言
    warehouseSelectAll: '全選択',
    warehouseAutoCalculateMaterial: '副資材を自動計算',
    warehousePoints: '点',
    yuan: '元',
    warehouseNoData: '倉庫商品がありません',
    warehouseTabPending: 'この倉庫一覧は次の段階で実装します',
    warehouseExpand: '展開',
    warehouseOrderRemark: '注文管理備考',
    warehouseSubaccount: '注文サブアカウント',
    warehouseStorageInformation: '倉庫保管情報',
    warehouseRemainingFreeDays: '無料保管残日数',
    warehouseForbiddenGoods: '禁輸',
    warehouseExchangeRate: '注文為替レート',
    warehouseCurrentStock: '倉庫数量',
    warehouseBoxedCount: '梱包済み数量',
    warehousePendingCount: '提出待ち数量',
    warehouseUnboxedCount: '未梱包数量',
    warehouseMaterialType: '副資材タイプ',
    warehouseMaterialConsume: '消費数量',
    warehouseBoundMaterial: '副資材設定済み',
    warehouseUnboundMaterial: '副資材未設定',
    warehouseFirstInboundAt: '初回入庫日時',
    warehouseFirstPurchaseInboundAt: '初回仕入入庫日時',
    warehouseUsedFreeDays: '無料保管経過日数',
    warehouseExporting: '倉庫データを出力中',
    warehouseExportFailed: '倉庫データの出力に失敗しました',
    productAuditType: '審査タイプ',
    productNormal: '正常商品',
    productNoNeedToMaintain: 'メンテナンス不要',
    warehouseStorageDays: '保管日数',
    smallOrderSpecialFee: '小口注文特別手数料',
    smallOrderFeeActive: '適用',
    smallOrderFeeInactive: '適用しない',
  },
}
